import React, { useState, useContext, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Favourite from '../Favourite_copy'
import { Image } from 'react-shimmer'
import './cards.css'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import moment from 'moment'
import { getTimeInterval } from '../../utils/commonFunctions'
import { useHistory } from 'react-router-dom'
import FavouriteCheckbox from '../../Product/components/atoms/FavoriteCheckbox'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import Timer from '../../Product/common/timer'
import Bidding from '../../Product/components/molecules/Bidding/BiddingItem'
import Facebook from '../../utils/CommonFunctionality/Share/Facebook'
import Whatsapp from '../../utils/CommonFunctionality/Share/Whatsapp'
import Twitter from '../../utils/CommonFunctionality/Share/Twitter'
import Email from '../../utils/CommonFunctionality/Share/Email'
import Pinterest from '../../utils/CommonFunctionality/Share/Pinterest'
import Copy from '../../utils/CommonFunctionality/Share/Copy'
import Biddingforwardandreverse from '../../Product/components/molecules/Bidding/biddingforwardandreverse'
import {
    currencyFormat,
    dateFormatFront,
    handleRedirectInternal,
    sellerNameFormat,
} from '../../Product/common/components'
import { Button, Tooltip, Popover } from '@material-ui/core'
import AddToCalendar from '../../Product/components/molecules/AddToCalendar'
import CartContext from '../../Product/context/cart/cartContext'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { allCondition } from '../../utils'
import axios from 'axios'
import userContext from '../../Product/context/user/userContext'
import CurrencyConverterFormat from '../../utils/CommonFunctionality/CurrencyConverter/CurrencyConverterFormat'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import productContext from '../../Product/context/product/productContext'
import alertContext from '../../Product/context/alert/alertContext'
import Qtyinputcard from '../../Product/common/Qtyinputcard'
import { Rating } from '@material-ui/lab'
import Bidhistory from '../Bidhistory'
import ImageZoom from '../ImageZoom'
import WizardTermsPopup from '../../Themes/Liquidation_two/AuctionTerms/wizardTermsPopup'
import { useAuctionTerms } from '../../Themes/Liquidation_two/AuctionTerms/useAuctionTerms'
import { InfoOutlined, LocalShippingOutlined } from '@material-ui/icons'

const GridItem = ({
    noTimer,
    noBuyNow,
    noBidButton,
    data,
    handleClick,
    type,
    link,
    isTheme,
    timerTheme,
    cardTheme,
    additionalCardTheme,
    bidHistry,
    bidBtnLabel,
    getAllProducts,
    lotImages,
    auction_and_buynow,
    lotBidding,
    currencyType,
    fromSearch,
    className,
    bidStatus,
    showCondition,
    showLocation,
    timerIcon,
    auctionTimer,
    viewProduct,
    setViewProduct,
    lotData,
    lotDetails,
    productViewLink,
    showEstimate,
    audio,
    removePopup,
    need_end_date,
    next_week_date,
    is_registered,
    // setAlert,
    private_auction,
    isMarineTheme,
    fromComponent,
    showDateNumber,
    details,
}) => {
    const history = useHistory()
    const addDefaultSrc = (e) => {
        e.target.src = `${global?.storeDetails?.logoValue}`
        e.target.className = `gridImage default`
    }
    const isTab = useMediaQuery({
        query: '(max-width: 768px)',
    })
    const authContext = useContext(AuthContext)
    const [showTooltip, setShowTooltip] = useState(false)
    const cartContext = useContext(CartContext)
    const [selectedProduct, setSelectedProduct] = useState({})
    const { t } = useTranslation()
    const {
        addToCart,
        getUserCart,
        removeFromCart,
        responseStatus,
        buyer_cartitems,
        clearResponse,
    } = cartContext
    const { setAlert } = useContext(alertContext)
    const { productLocalState } = useContext(productContext)
    const { countryValues } = useContext(userContext)
    const infoRef = useRef(null)
    const { isAuthenticated, user } = authContext
    const [active, setActive] = useState(false)

    const [reload, setReload] = useState(false)
    const [historyData, setHistoryData] = useState({})

    const [bidText, setBidText] = useState('Bid Now')
    const [reviewId, setReviewId] = useState('')
    const [notesId, setNotesId] = useState(false)

    const [activelocation, setActiveLocation] = useState('')
    const [showInfo, setShowInfo] = useState(false)

    const toggleInfo = () => {
        setShowInfo(!showInfo)
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (infoRef.current && !infoRef.current.contains(event.target)) {
                setShowInfo(false) // hide when clicked outside
            }
        }

        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])
    useEffect(() => {
        if (data?.auction_city) {
            setActiveLocation(data?.auction_city)
        } else {
            setActiveLocation(data?.product_city)
        }
    }, [data?.id])

    useEffect(() => {
        if (buyer_cartitems.results) {
            if (data.id) {
                let position = _.findIndex(buyer_cartitems.results, {
                    project_id: data.id,
                })
                position === -1 ? setActive(false) : setActive(true)
            }
        }
    }, [buyer_cartitems.results, data.id])

    const result = Math.round(
        (currencyFormat(parseFloat(data.wprice).toFixed(2), '%') /
            currencyFormat(parseFloat(data.mprice).toFixed(2), '%')) *
            100,
    )

    const handleBidHistoryModal = (data) => {
        if ((data.bid_count && data.bid_count !== 0) || (data.nobids && data.nobids !== 0)) {
            setHistoryData({
                product_id: data.id,
                end: moment(data.date_closed).isValid() ? data.date_closed : oneYear,
            })
        }
    }
    const showReview = (e) => {
        setReviewId('showReview')
    }

    const showNotes = (e) => {
        setNotesId(!notesId)
    }

    useEffect(() => {
        const currencySplit = Math.round(data.wprice / data.mprice) * 100
        return currencySplit
    }, [data.wprice])
    const isWizardTheme = document.body.classList[1] == 'wizardTheme'
    const isBidnaa = document.body.classList[1] == 'bidNaa'
    const handleCart = async (id, date_added) => {
        if (global?.storeConfigration?.guest_user_login?.value) {
            if (active) {
                removeFromCart({ id })
            } else
                addToCart({
                    id: data.id,
                    qty: data.qty,
                    manufacture_date:
                        data.custom_field_9 && data.custom_field_9.includes('}')
                            ? JSON.parse(data.custom_field_9)?.inventory_date
                            : '',
                })
        } else {
            if (date_added && new Date(date_added) > new Date()) {
                return setAlert('Wait until auction starts!', 'warning')
            }

            if (!user?.card_paymentid) {
                setAlert('Add a card to buy!', 'error')
                return handleRedirectInternal(history, 'dashboard/cards')
            }
            if (active) {
                removeFromCart({ id })
            } else
                addToCart({
                    id: data.id,
                    qty: data.qty,
                    manufacture_date:
                        data.custom_field_9 && data.custom_field_9.includes('}')
                            ? JSON.parse(data.custom_field_9)?.inventory_date
                            : '',
                })
        }
    }

    const { showPopup, setShowPopup, checkTermsAndProceed, acceptTerms } = useAuctionTerms({
        onAccepted: (auctionId) => {},
    })

    const categoryTypes = {}
    global.allCategories.map((catgeory) => (categoryTypes[catgeory.id] = catgeory))

    // useEffect(() => {
    //     if (responseStatus) {
    //         if (responseStatus.from === 'addToCart') {
    //             if (responseStatus.status === 'success') {
    //                 console.log('++++++++++++')
    //                 getUserCart()
    //                 clearResponse()
    //             }
    //         } else if (responseStatus.from === 'removeFromCart') {
    //             if (responseStatus.status === 'success') {
    //                 getUserCart()
    //                 clearResponse()
    //             }
    //         }
    //     }
    // }, [responseStatus])

    useEffect(() => {
        if (data?.extra_fields?.includes('}')) {
            let parse = JSON.parse(data.extra_fields)
            Object.keys(parse).map((val) => {
                data[val] = parse[val]
            })
        }
    }, [])
    const getBidText = (data) => {
        if (
            isAuthenticated &&
            (data.latestbid_user != null || data.highest_bidder_user_id != null) &&
            user?.id != undefined
        ) {
            if (data.auction) {
                if (
                    (data.latestbid_user == user?.id || data.highest_bidder_user_id == user?.id) &&
                    data.wprice >= data.rprice
                ) {
                    if (data.market_status == 'open') {
                        setBidText('Winning')
                    } else if (data.market_status == 'sold') {
                        setBidText('Won')
                    }
                } else if (
                    data.latestbid_user != user?.id &&
                    (data.currentUserBidAmount || data.bid_or_not || data.cbidnot)
                ) {
                    if (data.market_status == 'open') {
                        setBidText('Outbid')
                    } else if (data.market_status == 'sold') {
                        setBidText('Lost')
                    }
                } else {
                    setBidText('Bid Now')
                }
            }
        } else {
            setBidText('Bid Now')
        }
    }
    const conditionTooltip = data.auctionnotes?.trim()?.toLowerCase()?.includes('new')
        ? 'Looks unused, no noticeable wear'
        : data.auctionnotes?.trim()?.toLowerCase()?.includes('open box')
        ? 'Packaging opened, item unused or tested'
        : data.auctionnotes?.trim()?.toLowerCase()?.includes('excellent')
        ? 'Like new, minimal to no signs of use'
        : data.auctionnotes?.trim()?.toLowerCase()?.includes('damage')
        ? 'Non-functional or needs repair'
        : ''
    useEffect(() => {
        getBidText(data)
    }, [data.wprice, user?.id, isAuthenticated])

    const [countryList, setCountryList] = useState([])

    const isArtTheme = document.querySelector('body').classList.contains('artTheme')
    const isHyperMicroTheme = document.querySelector('body').classList.contains('hyperMicro')
    const isPrimeBidsTheme = document.querySelector('body').classList.contains('primeBids')
    const isBidDepotProject = document.querySelector('body').classList.contains('BidAuction')
    const checkEmursTheme = document.body.className == 'liquidationTwo emursMck'
    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'
    const isBargainTheme = document.body.classList[1] == 'bargains'

    const getLocationData = () => {
        var body = {
            countryCode: 38,
        }

        return axios
            .post(`${process.env.REACT_APP_URL}fetchLocation`, body)
            .then(function (response) {
                if (response.data.success) {
                    setCountryList([
                        response.data.country.find((value) => parseInt(value.location_id) === 224),
                        ...response.data.country.filter(
                            (value) => parseInt(value.location_id) !== 224,
                        ),
                    ])
                }
            })
            .catch(function (error) {
                // console.log(error)
            })
    }

    useEffect(() => {
        // getLocationData()
        getBidText(data)
    }, [data])

    // share icons funa

    const [shareAnchorEl, setShareAnchorEl] = useState(null)

    const handleShareClick = (event) => {
        setShareAnchorEl(event.currentTarget)
    }

    const handleShareClose = () => {
        setShareAnchorEl(null)
    }

    const openshare = Boolean(shareAnchorEl)
    const id = open ? 'simple-popover' : undefined

    const hanlderedirection = async (id) => {
        if (isWizardTheme) {
            const allowed = await checkTermsAndProceed({
                auctionId: data?.lotof,
            })
            if (!allowed) {
                return
            }
        }
        if (parseInt(is_registered) == 0 && parseInt(private_auction) == 1) {
            setAlert('Please register auction and continue!', 'error')
        } else {
            if (global.storeDetails?.theme === 20) {
                handleClick(id)
            }
            history.push({
                pathname: `/productView/${id}`,
                state: { lotid: lotDetails },
            })
        }
    }

    const dateAdded = new Date(data.date_added)
    const currentDate = new Date()
    const shouldShowMessage = currentDate < dateAdded

    const getStateShortForm = (state) => {
        if (!state) return ''

        const lowerState = state.toLowerCase()

        if (lowerState === 'virginia') return 'VA'

        return state.slice(0, 2).toUpperCase()
    }

    return (
        <div
            className={`card grid-card a gallery ${
                fromComponent == 'home' ? '' : 'fromSearch'
            } ${className} 
            ${bidText === 'Winning' && 'winningcard'} 
            ${bidText === 'Outbid' && 'losingcard'} `}
            id={`lot-${data.id}`}
            key={data.id}
        >
            {cardTheme == 'liquidationTwo' && (
                <>
                    {!isBidDepotProject && (
                        <>
                            <div
                                className={
                                    `${
                                        checkBidShopTheme ? '' : 'row'
                                    } lctnFavWrapper  d-flex align-items-center justify-content-between` +
                                    ' ' +
                                    reviewId
                                }
                            >
                                <div
                                    className={
                                        isPrimeBidsTheme
                                            ? 'card-favourite col-md-5 col-5'
                                            : isWizardTheme || checkBidShopTheme
                                            ? 'card-favourite'
                                            : 'card-favourite col-md-4 col-4'
                                    }
                                >
                                    <div className="notesFavWrapper d-flex align-items-center justify-content-between">
                                        {data.market_status == 'open' && (
                                            <FavouriteCheckbox
                                                watchlisted={
                                                    data.watchlistid ||
                                                    data.watchlisted ||
                                                    data.isFav ||
                                                    data.watch
                                                }
                                                project_id={data.id}
                                                getAllProducts={getAllProducts}
                                                data={data}
                                                from={'card'}
                                                viewProduct={viewProduct}
                                                setViewProduct={setViewProduct}
                                            />
                                        )}

                                        {isPrimeBidsTheme && data?.style_period ? (
                                            <div
                                                className="lctnTxtWrpr notes"
                                                onClick={() => showNotes()}
                                            >
                                                <span className="location-class">Notes</span>
                                            </div>
                                        ) : null}
                                        {cardTheme === 'liquidationTwo' && (
                                            <>
                                                {isHyperMicroTheme && (
                                                    <>
                                                        <span
                                                            aria-describedby={id}
                                                            className="material-icons ml-2 share-Icon"
                                                            onClick={handleShareClick}
                                                        >
                                                            share
                                                        </span>
                                                        <Popover
                                                            id={id}
                                                            open={openshare}
                                                            anchorEl={shareAnchorEl}
                                                            onClose={handleShareClose}
                                                            anchorOrigin={{
                                                                vertical: 'bottom',
                                                                horizontal: 'center',
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'center',
                                                            }}
                                                        >
                                                            <div className="pvMiscActions mb-0 p-2">
                                                                <Facebook
                                                                    path={`/search?product=${data.id}`}
                                                                    title={data.title}
                                                                />
                                                                <Whatsapp
                                                                    path={`/search?product=${data.id}`}
                                                                    title={data.title}
                                                                />
                                                                {global.storeConfigration
                                                                    ?.disable_twitter_sharing
                                                                    ?.value != 1 ? (
                                                                    <Twitter
                                                                        path={`/search?product=${data.id}`}
                                                                        title={data.title}
                                                                    />
                                                                ) : null}
                                                                <Email
                                                                    path={`/search?product=${data.id}`}
                                                                    subject={data.title}
                                                                    body={data.description}
                                                                />
                                                                {global.storeConfigration
                                                                    ?.disable_pinterest_sharing
                                                                    ?.value != 1 ? (
                                                                    <Pinterest
                                                                        path={`/search?product=${data.id}`}
                                                                        title={data.title}
                                                                        media={
                                                                            `${
                                                                                data.content_head1 ===
                                                                                '0'
                                                                                    ? process.env
                                                                                          .REACT_APP_BASE_URL +
                                                                                      'uploads/product/'
                                                                                    : process.env
                                                                                          .REACT_APP_PRODUCT_IMAGE_URL
                                                                            }` + data.avatar
                                                                        }
                                                                    />
                                                                ) : null}
                                                                <div
                                                                    className="cpyToClipDiv"
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    <Copy
                                                                        text={`/search?product=${data.id}`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Popover>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className={
                                        isPrimeBidsTheme
                                            ? 'card-location col-md-7 col-7'
                                            : checkBidShopTheme
                                            ? 'card-location'
                                            : 'card-location col-md-8 col-8'
                                    }
                                >
                                    <div className="lctnTxtWrpr d-flex align-items-center justify-content-end">
                                        <span className="material-icons">location_on</span>
                                        <span className="location-class">
                                            {isPrimeBidsTheme &&
                                            data?.auction_city &&
                                            data?.auction_state
                                                ? `${data?.auction_city}, ${data?.auction_state}`
                                                : checkBidShopTheme && data?.auction_state
                                                ? data?.auction_state
                                                : data?.auction_city ||
                                                  productLocalState?.globalLocation}
                                        </span>
                                    </div>
                                </div>
                                {isWizardTheme && (
                                    <>
                                        <img
                                            src="/assets/images/wizardAuctions/sendImg.svg"
                                            className="share-Icon"
                                            onClick={handleShareClick}
                                        ></img>
                                        <Popover
                                            id={id}
                                            open={openshare}
                                            anchorEl={shareAnchorEl}
                                            onClose={handleShareClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                        >
                                            <div className="pvMiscActions mb-0 p-2">
                                                <Facebook
                                                    path={`/search?product=${data.id}`}
                                                    title={data.title}
                                                />
                                                <Whatsapp
                                                    path={`/search?product=${data.id}`}
                                                    title={data.title}
                                                />
                                                {global.storeConfigration?.disable_twitter_sharing
                                                    ?.value != 1 ? (
                                                    <Twitter
                                                        path={`/search?product=${data.id}`}
                                                        title={data.title}
                                                    />
                                                ) : null}
                                                <Email
                                                    path={`/search?product=${data.id}`}
                                                    subject={data.title}
                                                    body={data.description}
                                                />
                                                {global.storeConfigration?.disable_pinterest_sharing
                                                    ?.value != 1 ? (
                                                    <Pinterest
                                                        path={`/search?product=${data.id}`}
                                                        title={data.title}
                                                        media={
                                                            `${
                                                                data.content_head1 === '0'
                                                                    ? process.env
                                                                          .REACT_APP_BASE_URL +
                                                                      'uploads/product/'
                                                                    : process.env
                                                                          .REACT_APP_PRODUCT_IMAGE_URL
                                                            }` + data.avatar
                                                        }
                                                    />
                                                ) : null}
                                                <div
                                                    className="cpyToClipDiv"
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <Copy text={`/productView/${data.id}`} />
                                                </div>
                                            </div>
                                        </Popover>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </>
            )}
            <div className={'grid-img-wrap' + ' ' + reviewId}>
                {isBidDepotProject && cardTheme === 'bidAuction' && (
                    <>
                        {!isBargainTheme ? (
                            <div className="gridDivView">
                                <div className="lctnTxtWrpr d-flex align-items-center justify-content-end">
                                    <span className="material-icons">location_on</span>
                                    <span className="location-class">{activelocation}</span>
                                </div>
                            </div>
                        ) : (
                            <div className="favWatchlist">
                                {data.market_status == 'open' && (
                                    <FavouriteCheckbox
                                        watchlisted={
                                            data.watchlistid ||
                                            data.watchlisted ||
                                            data.isFav ||
                                            data.watch
                                        }
                                        project_id={data.id}
                                        // watchListText
                                        getAllProducts={getAllProducts}
                                        data={data}
                                        from={'card'}
                                        viewProduct={viewProduct}
                                        setViewProduct={setViewProduct}
                                    />
                                )}
                            </div>
                        )}
                    </>
                )}
                {cardTheme === 'bidAuction' ? (
                    <>
                        {bidStatus === true && data.auction != 0 ? (
                            <>
                                {bidText == 'Winning' ? (
                                    <p className="wngSts grnTxt">
                                        {!isWizardTheme ? 'You Are Winning!' : 'Winning'}
                                    </p>
                                ) : bidText == 'Won' ? (
                                    <p className="wngSts grnTxt">
                                        {!isWizardTheme ? 'You Won!' : 'Won'}
                                    </p>
                                ) : bidText == 'Outbid' ? (
                                    <p className="wngSts LsgTxt">
                                        {!isWizardTheme ? 'You Are Losing' : 'Losing'}
                                    </p>
                                ) : bidText == 'Lost' ? (
                                    <p className="wngSts LsgTxt">
                                        {!isWizardTheme ? 'You Lost' : 'Lost'}
                                    </p>
                                ) : data.market_status == 'open' ? (
                                    <p className="wngSts grnTxt">
                                        {shouldShowMessage ? 'Upcoming' : 'Active'}
                                    </p>
                                ) : data.market_status == 'sold' ? (
                                    <p className="wngSts LsgTxt">Ended</p>
                                ) : (
                                    <p className="wngSts"></p>
                                )}
                            </>
                        ) : (
                            ''
                        )}
                    </>
                ) : null}
                {cardTheme === 'carAuction' ? (
                    <>
                        <FavouriteCheckbox
                            watchlisted={
                                data.watchlistid || data.watchlisted || data.isFav || data.watch
                            }
                            project_id={data.id}
                            getAllProducts={getAllProducts}
                            data={data}
                            from={'card'}
                            viewProduct={viewProduct}
                            setViewProduct={setViewProduct}
                        />
                        {type != 'buynow' && type == 'Auction'
                            ? ''
                            : isAuthenticated && (
                                  <Button
                                      className={`cartBtn crActnCart ${active ? 'active' : ''} ${
                                          cardTheme === 'carAuction' && data.buynow == 0
                                              ? 'd-none'
                                              : ''
                                      }`}
                                      onClick={() => handleCart(data.id, data?.date_added)}
                                      disabled={data.buynow == 0}
                                      //   disabled={
                                      //       data.buynow == 0 ||
                                      //       data.market_status == 'sold' ||
                                      //       parseInt(data.bprice) <
                                      //           parseInt(data.wprice)
                                      //   }
                                  >
                                      <span className="material-icons-outlined">
                                          {active ? 'shopping_cart_checkout' : 'add_shopping_cart'}
                                      </span>
                                  </Button>
                              )}
                    </>
                ) : (
                    ''
                )}
                {isBidDepotProject && cardTheme === 'bidAuction' && (
                    <>
                        {shouldShowMessage && (
                            <div className="soldWrapper">
                                <p>Not Started</p>
                            </div>
                        )}
                    </>
                )}
                {global?.storeConfigration?.sold_status?.value == '1' || isWizardTheme ? (
                    <></>
                ) : (
                    <>
                        {data.market_status === 'sold' && (
                            <div className="soldWrapper">
                                <p>SOLD</p>
                            </div>
                        )}
                        {data.market_status === 'closed' && (
                            <div className="soldWrapper">
                                <p>UNSOLD</p>
                            </div>
                        )}
                    </>
                )}

                {isPrimeBidsTheme || checkBidShopTheme ? (
                    <div className="img-notes-wrap">
                        <ImageZoom
                            src={`${
                                data.content_head1 === '0' || data.store_id === 0
                                    ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                    : process.env.REACT_APP_PRODUCT_IMAGE_URL
                            }${
                                global.storeConfigration?.image_compression?.value == 1
                                    ? 'thumb_'
                                    : ''
                            }${
                                (lotImages?.length && lotImages[0]?.file_name) ||
                                (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                                data.file_name ||
                                data.avatar_vc
                            }`}
                            // width={260}
                            // height={220}
                        >
                            <LazyLoadImage
                                src={`${
                                    data.content_head1 === '0' || data.store_id === 0
                                        ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                        : process.env.REACT_APP_PRODUCT_IMAGE_URL
                                }${
                                    global.storeConfigration?.image_compression?.value == 1
                                        ? 'thumb_'
                                        : ''
                                }${
                                    (lotImages?.length && lotImages[0]?.file_name) ||
                                    (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                                    data.file_name ||
                                    data.avatar_vc
                                }`}
                                effect="blur"
                                placeholderSrc="/assets/svg/imageLoading.svg"
                                height="100%"
                                width="100%"
                                className="gridImage"
                                //onClick={() => handleClick(data.id)}
                                onError={addDefaultSrc}
                                alt={data.title}
                                onClick={() =>
                                    productViewLink
                                        ? history.push({
                                              pathname: productViewLink,
                                          })
                                        : global.storeDetails?.theme === 9
                                        ? hanlderedirection(data.id)
                                        : global.storeDetails?.theme === 20
                                        ? hanlderedirection(data.id)
                                        : isWizardTheme
                                        ? hanlderedirection(data.id)
                                        : cardTheme === 'carAuction'
                                        ? history.push({
                                              pathname: `/productView/${data.id}`,
                                              state: { lotid: lotDetails },
                                          })
                                        : handleClick(data.id)
                                }
                                srcSet={`${
                                    data.content_head1 === '0' || data.store_id === 0
                                        ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                        : process.env.REACT_APP_PRODUCT_IMAGE_URL
                                }${
                                    global.storeConfigration?.image_compression?.value == 1
                                        ? 'thumb_'
                                        : ''
                                }${
                                    (lotImages?.length && lotImages[0]?.file_name) ||
                                    (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                                    data.file_name ||
                                    data.avatar_vc
                                }`}
                                sizes="(max-width: 600px) 400px, 800px"
                            />
                        </ImageZoom>

                        {notesId && (
                            <div className="grid-notes">
                                <div className="notes-text">
                                    <p
                                        className="gaDesc"
                                        dangerouslySetInnerHTML={{
                                            __html: data.style_period,
                                        }}
                                    ></p>
                                </div>
                                <PrimaryButton
                                    label={'More Info'}
                                    onClick={() => {
                                        handleClick(data.id)
                                    }}
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <>
                        <div className="img-notes-wrap">
                            <LazyLoadImage
                                src={`${
                                    data.content_head1 === '0' || data.store_id === 0
                                        ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                        : process.env.REACT_APP_PRODUCT_IMAGE_URL
                                }${
                                    global.storeConfigration?.image_compression?.value == 1
                                        ? 'thumb_'
                                        : ''
                                }${
                                    (lotImages?.length && lotImages[0]?.file_name) ||
                                    (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                                    data.file_name ||
                                    data.avatar_vc
                                }`}
                                effect="blur"
                                placeholderSrc="/assets/svg/imageLoading.svg"
                                height="100%"
                                width="100%"
                                className="gridImage"
                                //onClick={() => handleClick(data.id)}
                                onError={addDefaultSrc}
                                alt={data.title}
                                onClick={() =>
                                    productViewLink
                                        ? history.push({
                                              pathname: productViewLink,
                                          })
                                        : global.storeDetails?.theme === 9
                                        ? hanlderedirection(data.id)
                                        : global.storeDetails?.theme === 20
                                        ? hanlderedirection(data.id)
                                        : isWizardTheme
                                        ? hanlderedirection(data.id)
                                        : cardTheme === 'carAuction'
                                        ? history.push({
                                              pathname: `/productView/${data.id}`,
                                              state: { lotid: lotDetails },
                                          })
                                        : handleClick(data.id)
                                }
                            />

                            {notesId && (
                                <div className="grid-notes">
                                    <div className="notes-text">
                                        <p
                                            className="gaDesc"
                                            dangerouslySetInnerHTML={{
                                                __html: data.style_period,
                                            }}
                                        ></p>
                                    </div>
                                    <PrimaryButton
                                        label={'More Info'}
                                        onClick={() => {
                                            handleClick(data.id)
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className="bargainTimer d-none">
                            {!noTimer && data.date_closed && (
                                <div
                                    className={`gcTimer primeTmCrd hoTimer ${
                                        data.buynow === 1 && data.auction === 0 ? 'noBackDrop' : ''
                                    }`}
                                >
                                    {(data.market_status === 'open' && data.auction) ||
                                    (data.market_status === 'open' && auction_and_buynow) ? (
                                        <Timer
                                            date_added={data.date_added}
                                            date_closed={data.date_closed}
                                            withText={1}
                                            endText={'TIME REMAINING' + ''}
                                            startText={'Starts IN' + ''}
                                            theme={timerTheme}
                                            audio={audio}
                                            product_id={data.id}
                                            viewProduct={viewProduct}
                                            setViewProduct={setViewProduct}
                                            daysText=" Days "
                                            hoursText="h "
                                            minutesText="m "
                                            secondsText="s "
                                        />
                                    ) : (
                                        <>
                                            {data.buynow === 0 ? (
                                                <span className="closedText">Auction Closed</span>
                                            ) : (
                                                <div className="closedText"></div>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </>
                )}
                {cardTheme === 'LotsAuction' && (
                    <div className="lotAuctionCart">
                        {type != 'buynow' && type == 'Auction'
                            ? ''
                            : isAuthenticated &&
                              parseInt(data.wprice) <= parseInt(data.bprice) && (
                                  <Button
                                      className={`cartBtn ${active ? 'active' : ''} `}
                                      onClick={() => handleCart(data.id, data?.date_added)}
                                      disabled={data.buynow == 0 || user?.status == 'suspended'}
                                  >
                                      <span className="material-icons-outlined">
                                          {active ? 'shopping_cart_checkout' : 'add_shopping_cart'}
                                      </span>
                                  </Button>
                              )}
                    </div>
                )}
                {(cardTheme == 'multiseller' ||
                    cardTheme == 'LotsAuction' ||
                    cardTheme == 'HeavyEquipment' ||
                    cardTheme == 'fundRaiser' ||
                    cardTheme == 'auctioneer') &&
                    data.market_status == 'open' && (
                        <FavouriteCheckbox
                            watchlisted={data.watchlistid || data.watchlisted || data.isFav}
                            project_id={data.id}
                            from="card"
                            getAllProducts={getAllProducts}
                            viewProduct={viewProduct}
                            setViewProduct={setViewProduct}
                            theme={cardTheme}
                            data={data}
                        />
                    )}
                {global.pluginConfiguration?.most_viewed?.enable == 1 && data.viewers ? (
                    <p className="viewsCountValue">Viewers: {data.viewers}</p>
                ) : null}
                {(cardTheme === 'multiseller' ||
                    cardTheme === 'liquidationTwo' ||
                    global.storeDetails.theme == 19) &&
                bidStatus === true &&
                data.auction != 0 ? (
                    <>
                        {bidText == 'Winning' ? (
                            <p className="wngSts grnTxt">
                                {!isWizardTheme ? 'You Are Winning!' : 'Winning'}
                            </p>
                        ) : bidText == 'Won' ? (
                            <p className="wngSts grnTxt">{!isWizardTheme ? 'You Won!' : 'Won'}</p>
                        ) : bidText == 'Outbid' ? (
                            <p className="wngSts LsgTxt">
                                {!isWizardTheme ? 'You Are Losing' : 'Losing'}
                            </p>
                        ) : bidText == 'Lost' ? (
                            <p className="wngSts LsgTxt">{!isWizardTheme ? 'You Lost' : 'Lost'}</p>
                        ) : (
                            <p className="wngSts"></p>
                        )}
                    </>
                ) : (
                    ''
                )}
            </div>
            <div className={'card-body' + ' ' + reviewId}>
                {cardTheme === 'ArtAuction' ? (
                    <>
                        <div className="ttlInfo">
                            {data.title !== undefined && (
                                <h5
                                    className="name-txt cursorDecoy"
                                    onClick={() =>
                                        productViewLink
                                            ? history.push({
                                                  pathname: productViewLink,
                                              })
                                            : handleClick(data.id)
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: data.title,
                                    }}
                                />
                            )}
                            {global?.storeConfigration?.lot_sequence_order?.value == 1 ? (
                                <p className="gpAddnInfo">
                                    Lot #: <span>{data?.deed_document || '-'}</span>
                                </p>
                            ) : (
                                <p className="gpAddnInfo">
                                    Lot Number:{' '}
                                    <span>{data?.lot_number !== '' ? data.lot_number : '-'}</span>
                                </p>
                            )}
                            <h6 className="galleryPrice">
                                {data.auction && data.wprice ? (
                                    <>
                                        {data.market_status == 'closed' ? (
                                            <span>UnSold</span>
                                        ) : (
                                            <div className="d-flex align-item-center">
                                                <span>
                                                    {isMarineTheme &&
                                                        (data.market_status == 'sold'
                                                            ? 'Sold'
                                                            : data.nobids || data.bid_count
                                                            ? 'Current'
                                                            : 'Start') + `${' '}Price:${' '}`}
                                                </span>
                                                <p>
                                                    {currencyFormat(
                                                        parseFloat(data.wprice).toFixed(2),
                                                        currencyType,
                                                    )}
                                                </p>
                                                <p>
                                                    <CurrencyConverterFormat amount={data.wprice} />
                                                </p>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {' '}
                                        {data.market_status == 'closed' ? (
                                            <span>UnSold</span>
                                        ) : (
                                            <>
                                                {data.buynow && data.bprice ? (
                                                    <span className="prcTxtVal">
                                                        {currencyFormat(
                                                            parseFloat(data.bprice).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.bprice}
                                                        />
                                                    </span>
                                                ) : (
                                                    <span className="gridNotAvailable">
                                                        Not Available
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </h6>
                        </div>
                        {isTab ? (
                            <>
                                {!noTimer &&
                                    additionalCardTheme == 'collectibles' &&
                                    data.date_closed && (
                                        <div
                                            className={`gcTimer timerMob ${
                                                data.buynow === 1 ? 'noBackDrop' : ''
                                            }`}
                                        >
                                            {(data.market_status === 'open' && data.auction) ||
                                            (data.market_status === 'open' &&
                                                auction_and_buynow) ? (
                                                <Timer
                                                    date_added={data.date_added}
                                                    date_closed={data.date_closed}
                                                    withText={1}
                                                    endText={
                                                        isArtTheme
                                                            ? t('time_left')
                                                            : t('time_left') + ': '
                                                    }
                                                    startText={t('starts_in') + ': '}
                                                    theme={timerTheme}
                                                    audio={audio}
                                                />
                                            ) : (
                                                <>
                                                    {data.buynow === 0 ? (
                                                        <span className="closedText">
                                                            Auction Closed
                                                        </span>
                                                    ) : (
                                                        <div className="closedText"></div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                <div
                                    className={`${
                                        isAuthenticated ? 'loggedIn' : 'notLogged'
                                    } mnCardCntnr d-flex align-items-center justify-content-between`}
                                >
                                    {isArtTheme && isAuthenticated && (
                                        <>
                                            {data.market_status == 'open' && (
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <FavouriteCheckbox
                                                        watchlisted={
                                                            data.watchlistid ||
                                                            data.watchlisted ||
                                                            data.isFav
                                                        }
                                                        project_id={data.id}
                                                        from="card"
                                                        getAllProducts={getAllProducts}
                                                        viewProduct={viewProduct}
                                                        setViewProduct={setViewProduct}
                                                        data={data}
                                                    />
                                                    <span className="LikeTxt">Like</span>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    <div className="rtCrdCnr">
                                        {!isArtTheme && (
                                            <>
                                                {data.market_status == 'open' && (
                                                    <FavouriteCheckbox
                                                        watchlisted={
                                                            data.watchlistid ||
                                                            data.watchlisted ||
                                                            data.isFav
                                                        }
                                                        project_id={data.id}
                                                        from="card"
                                                        getAllProducts={getAllProducts}
                                                        viewProduct={viewProduct}
                                                        setViewProduct={setViewProduct}
                                                        data={data}
                                                    />
                                                )}
                                            </>
                                        )}
                                        <PrimaryButton
                                            btnSize="ml-3"
                                            onClick={() =>
                                                isAuthenticated
                                                    ? productViewLink
                                                        ? history.push({
                                                              pathname: productViewLink,
                                                          })
                                                        : handleClick(data.id)
                                                    : handleRedirectInternal(history, 'login')
                                            }
                                        >
                                            {isArtTheme ? (
                                                <>
                                                    {isAuthenticated ? t('Bid') : t('login_to_bid')}
                                                </>
                                            ) : (
                                                <>
                                                    {isAuthenticated
                                                        ? t('bid_now')
                                                        : t('login_to_bid')}
                                                </>
                                            )}
                                        </PrimaryButton>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div
                                    className={`${
                                        isAuthenticated ? 'loggedIn' : 'notLogged'
                                    } mnCardCntnr d-flex align-items-center justify-content-between`}
                                >
                                    {isArtTheme && isAuthenticated && (
                                        <>
                                            {data.market_status == 'open' && (
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <FavouriteCheckbox
                                                        watchlisted={
                                                            data.watchlistid ||
                                                            data.watchlisted ||
                                                            data.isFav
                                                        }
                                                        project_id={data.id}
                                                        from="card"
                                                        getAllProducts={getAllProducts}
                                                        viewProduct={viewProduct}
                                                        setViewProduct={setViewProduct}
                                                        data={data}
                                                    />
                                                    <span className="LikeTxt">{t('like')}</span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {!noTimer && data.date_closed && (
                                        <div
                                            className={`gcTimer ${
                                                data.buynow === 1 ? 'noBackDrop' : ''
                                            }`}
                                        >
                                            {(data.market_status === 'open' && data.auction) ||
                                            (data.market_status === 'open' &&
                                                auction_and_buynow) ? (
                                                <Timer
                                                    date_added={data.date_added}
                                                    date_closed={data.date_closed}
                                                    withText={1}
                                                    endText={
                                                        isArtTheme
                                                            ? t('time_left')
                                                            : t('time_left') + ': '
                                                    }
                                                    startText={t('starts_in') + ': '}
                                                    theme={timerTheme}
                                                    audio={audio}
                                                />
                                            ) : (
                                                <>
                                                    {data.buynow === 0 ? (
                                                        <span className="closedText">
                                                            Auction Closed
                                                        </span>
                                                    ) : (
                                                        <div className="closedText"></div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                    <div className="rtCrdCnr">
                                        {!isArtTheme && (
                                            <>
                                                {data.market_status == 'open' && (
                                                    <FavouriteCheckbox
                                                        watchlisted={
                                                            data.watchlistid ||
                                                            data.watchlisted ||
                                                            data.isFav
                                                        }
                                                        project_id={data.id}
                                                        from="card"
                                                        getAllProducts={getAllProducts}
                                                        viewProduct={viewProduct}
                                                        setViewProduct={setViewProduct}
                                                        data={data}
                                                    />
                                                )}
                                            </>
                                        )}
                                        <PrimaryButton
                                            btnSize="ml-3"
                                            onClick={() =>
                                                isAuthenticated
                                                    ? productViewLink
                                                        ? history.push({
                                                              pathname: productViewLink,
                                                          })
                                                        : handleClick(data.id)
                                                    : handleRedirectInternal(history, 'login')
                                            }
                                        >
                                            {isArtTheme ? (
                                                <>
                                                    {isAuthenticated ? t('bid') : t('login_to_bid')}
                                                </>
                                            ) : (
                                                <>
                                                    {isAuthenticated
                                                        ? t('bid_now')
                                                        : t('login_to_bid')}
                                                </>
                                            )}
                                        </PrimaryButton>
                                    </div>
                                </div>
                            </>
                        )}

                        {need_end_date && (
                            <>
                                {data.auction == 1 ? (
                                    <div className="text-center endDteTxt grid-last-paragraph">
                                        {data.market_status === 'open' ? (
                                            <>
                                                {new Date(next_week_date) <
                                                new Date(data.date_closed) ? (
                                                    <p className="mb-0">
                                                        Ends{' '}
                                                        {`${moment(data.date_closed)
                                                            .tz(
                                                                global?.storeConfigration
                                                                    ?.auction_view_time_zone?.value
                                                                    ? global?.storeConfigration
                                                                          ?.auction_view_time_zone
                                                                          ?.value
                                                                    : moment.tz.guess(),
                                                            )
                                                            .format('MMM Do')}, ${moment(
                                                            data.date_closed,
                                                        )
                                                            .tz(
                                                                global?.storeConfigration
                                                                    ?.auction_view_time_zone?.value
                                                                    ? global?.storeConfigration
                                                                          ?.auction_view_time_zone
                                                                          ?.value
                                                                    : moment.tz.guess(),
                                                            )
                                                            .format('h:mm a z')}`}
                                                    </p>
                                                ) : (
                                                    <p className="mb-0">
                                                        Ends on{' '}
                                                        {`${moment(data.date_closed)
                                                            .tz(
                                                                global?.storeConfigration
                                                                    ?.auction_view_time_zone?.value
                                                                    ? global?.storeConfigration
                                                                          ?.auction_view_time_zone
                                                                          ?.value
                                                                    : moment.tz.guess(),
                                                            )
                                                            .format('Do dddd')} at ${moment(
                                                            data.date_closed,
                                                        )
                                                            .tz(
                                                                global?.storeConfigration
                                                                    ?.auction_view_time_zone?.value
                                                                    ? global?.storeConfigration
                                                                          ?.auction_view_time_zone
                                                                          ?.value
                                                                    : moment.tz.guess(),
                                                            )
                                                            .format('h:mm a z')}`}
                                                    </p>
                                                )}
                                            </>
                                        ) : (
                                            <p className="mb-0">Auction Closed</p>
                                        )}
                                    </div>
                                ) : null}
                            </>
                        )}
                    </>
                ) : isBidDepotProject && cardTheme === 'bidAuction' ? (
                    <>
                        <div className="d-flex justify-content-between">
                            <small className="lotIDwithBids">Lot {data.lot_number}</small>
                            <small className="lotIDwithBids">
                                {data.nobids || data.bid_count || 0} Bid(s)
                            </small>
                        </div>
                        <h5
                            className="name-txt cursorDecoy mt-0 mb-3"
                            onClick={() =>
                                cardTheme === 'carAuction'
                                    ? history.push({
                                          pathname: `/productView/${data.id}`,
                                          state: { lotid: lotDetails },
                                      })
                                    : cardTheme === 'bidAuction'
                                    ? hanlderedirection(data.id)
                                    : productViewLink
                                    ? history.push({
                                          pathname: productViewLink,
                                      })
                                    : handleClick(data.id)
                            }
                            dangerouslySetInnerHTML={{
                                __html:
                                    cardTheme == 'auctioneer' &&
                                    data.category_id !=
                                        global?.storeConfigration?.similar_category?.value
                                        ? `${
                                              data.custom_field_9 &&
                                              data.custom_field_9.includes('}')
                                                  ? JSON.parse(data.custom_field_9)?.game_theme
                                                  : ''
                                          } ${data.subcategory
                                              ?.split(',')
                                              ?.map((val) => categoryTypes[val]?.description ?? '')
                                              ?.join(', ')}`
                                        : data.title,
                            }}
                        />
                        {!isBargainTheme ? (
                            <>
                                {data.mprice ? (
                                    <h6 className="galleryPrice rtlrPrice io">
                                        <span className="prcLabel">Retail Price: </span>
                                        <span className="prcTxtVal">
                                            {currencyFormat(
                                                parseFloat(data.mprice || 0).toFixed(2),
                                                currencyType,
                                            )}
                                            <CurrencyConverterFormat amount={data.mprice} />
                                        </span>
                                    </h6>
                                ) : (
                                    <h6 className="galleryPrice rtlrPrice">
                                        <span className="prcLabel">Retail Price: </span>
                                        <span className="prcTxtVal">-</span>
                                    </h6>
                                )}
                            </>
                        ) : (
                            <div className="flexPrice">
                                <div className="favGridBxx timer ba-wrap">
                                    <div
                                        className={`BiddingNum ${
                                            data.market_status === 'sold' ? 'sold' : ''
                                        }`}
                                    >
                                        <h4>
                                            {data.market_status === 'sold'
                                                ? 'SOLD BID'
                                                : data.market_status === 'closed'
                                                ? 'BID AMOUNT'
                                                : data?.latestbid
                                                ? 'CURRENT BID'
                                                : 'START BID'}
                                        </h4>

                                        <span className="curBidAmtt">
                                            {currencyFormat(
                                                parseFloat(
                                                    data.wprice ? data.wprice : data.bprice,
                                                ).toFixed(2),
                                                currencyType,
                                            )}
                                            <CurrencyConverterFormat amount={data.wprice} />
                                        </span>
                                    </div>

                                    {!noTimer && data.date_closed && (
                                        <div
                                            className={`gcTimer primeTmCrd noBargainTim hoTimer ${
                                                data.buynow === 1 && data.auction === 0
                                                    ? 'noBackDrop'
                                                    : ''
                                            }`}
                                        >
                                            {(data.market_status === 'open' && data.auction) ||
                                            (data.market_status === 'open' &&
                                                auction_and_buynow) ? (
                                                <Timer
                                                    date_added={data.date_added}
                                                    date_closed={data.date_closed}
                                                    withText={1}
                                                    endText={'TIME REMAINING' + ''}
                                                    startText={'Starts IN' + ''}
                                                    theme={timerTheme}
                                                    audio={audio}
                                                    product_id={data.id}
                                                    viewProduct={viewProduct}
                                                    setViewProduct={setViewProduct}
                                                    daysText=" Days "
                                                    hoursText="h "
                                                    minutesText="m "
                                                    secondsText="s "
                                                />
                                            ) : (
                                                <>
                                                    {data.buynow === 0 ? (
                                                        <span className="closedText">
                                                            Auction Closed
                                                        </span>
                                                    ) : (
                                                        <div className="closedText"></div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {data.mprice ? (
                                    <h6 className="galleryPrice rtlrPrice">
                                        <span className="prcLabel">Retail Price: </span>
                                        <span className="prcTxtVal">
                                            {currencyFormat(
                                                parseFloat(data.mprice || 0).toFixed(2),
                                                currencyType,
                                            )}
                                            <CurrencyConverterFormat amount={data.mprice} />
                                        </span>
                                    </h6>
                                ) : (
                                    <h6 className="galleryPrice rtlrPrice">
                                        <span className="prcLabel">Retail Price: </span>
                                        <span className="prcTxtVal">-</span>
                                    </h6>
                                )}
                            </div>
                        )}
                        <div className="favGridBxx mb-2">
                            <div className="galleryPriceCnt">
                                <h6 className="galleryPrice condition">
                                    <span>Condition: </span>
                                    {data.auctionnotes ? (
                                        <>
                                            <span
                                                className={`prcTxtVal ${
                                                    data.auctionnotes
                                                        ?.trim()
                                                        ?.toLowerCase()
                                                        ?.includes('brand')
                                                        ? 'text-success'
                                                        : data.auctionnotes
                                                              ?.trim()
                                                              ?.toLowerCase()
                                                              ?.includes('appears')
                                                        ? 'text-primary'
                                                        : data.auctionnotes
                                                              ?.trim()
                                                              ?.toLowerCase()
                                                              ?.includes('as-is')
                                                        ? 'text-danger'
                                                        : 'used'
                                                }`}
                                                onClick={toggleInfo}
                                                title={data.auctionnotes ? data.auctionnotes : '-'}
                                            >
                                                {data.auctionnotes ? data.auctionnotes : '-'}
                                            </span>
                                            {isBidDepotProject && (
                                                <span
                                                    className="material-icons"
                                                    onClick={toggleInfo}
                                                >
                                                    info
                                                </span>
                                            )}
                                            {isBidDepotProject && showInfo && (
                                                <span className="txtView info-popup" ref={infoRef}>
                                                    {
                                                        data.auctionnotes
                                                            ?.trim()
                                                            ?.toLowerCase()
                                                            ?.includes('brand')
                                                            ? `Item is unused and in the original retail packaging. Packaging may be
                        damaged, but the Item is guaranteed for functionality and completeness.
                        Please refer to item notes and pictures for what you will receive. If item
                        is misrepresented, a refund or credit will be issued at the managers
                        discretion as long as we are notified before you leave the premises. No
                        exceptions.`
                                                            : data.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('appears')
                                                            ? `Item may be open box but appears to be in new condition without any major
                        damage or defects. We do our best to examine each item for completeness and
                        functionality, but it is not guaranteed on Appears New items. Please refer
                        to item notes and pictures for what you will receive. We highly suggest
                        using auction preview times to examine the item in person before bidding. No
                        returns, credits, or exchanges on Appears New items.`
                                                            : data.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('as-is')
                                                            ? `Item could be damaged, missing parts, or not functional. Item has not been
                        deeply inspected and is sold as is. No returns, credits, or exchanges on as
                        is/for parts only items. Please see notes and pictures for condition
                        details. We highly suggest using auction preview times to examine the item
                        in person before bidding.`
                                                            : data.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('used')
                                                            ? `Item shows signs of previous use. Please see notes and pictures for
                        condition details. Although used items should be functional and complete, it
                        is not guaranteed. We highly suggest using auction preview times to examine
                        the item in person before bidding. No returns, credits, or exchanges on used
                        items.`
                                                            : data?.auctionnotes

                                                        // selectedProduct?.auctionnotes
                                                    }
                                                </span>
                                            )}
                                        </>
                                    ) : (
                                        '-'
                                    )}
                                </h6>
                            </div>
                            {!isBargainTheme ? (
                                <div className="favWatchlist">
                                    {data.market_status == 'open' && (
                                        <FavouriteCheckbox
                                            watchlisted={
                                                data.watchlistid ||
                                                data.watchlisted ||
                                                data.isFav ||
                                                data.watch
                                            }
                                            project_id={data.id}
                                            watchListText
                                            getAllProducts={getAllProducts}
                                            data={data}
                                            from={'card'}
                                            viewProduct={viewProduct}
                                            setViewProduct={setViewProduct}
                                        />
                                    )}
                                </div>
                            ) : null}
                        </div>
                        {!isBargainTheme ? (
                            <div className="favGridBxx timer ba-wrap">
                                <div
                                    className={`BiddingNum ${
                                        data.market_status === 'sold' ? 'sold' : ''
                                    }`}
                                >
                                    <h4>
                                        {data.market_status === 'sold'
                                            ? 'SOLD BID'
                                            : data.market_status === 'closed'
                                            ? 'BID AMOUNT'
                                            : data?.latestbid
                                            ? 'CURRENT BID'
                                            : 'START BID'}
                                    </h4>

                                    <span className="curBidAmtt">
                                        {currencyFormat(
                                            parseFloat(
                                                data.wprice ? data.wprice : data.bprice,
                                            ).toFixed(2),
                                            currencyType,
                                        )}
                                        <CurrencyConverterFormat amount={data.wprice} />
                                    </span>
                                </div>

                                {!noTimer && data.date_closed && (
                                    <div
                                        className={`gcTimer primeTmCrd noBargainTim hoTimer ${
                                            data.buynow === 1 && data.auction === 0
                                                ? 'noBackDrop'
                                                : ''
                                        }`}
                                    >
                                        {(data.market_status === 'open' && data.auction) ||
                                        (data.market_status === 'open' && auction_and_buynow) ? (
                                            <Timer
                                                date_added={data.date_added}
                                                date_closed={data.date_closed}
                                                withText={1}
                                                endText={'TIME REMAINING' + ''}
                                                startText={'Starts IN' + ''}
                                                theme={timerTheme}
                                                audio={audio}
                                                product_id={data.id}
                                                viewProduct={viewProduct}
                                                setViewProduct={setViewProduct}
                                                daysText=" Days "
                                                hoursText="h "
                                                minutesText="m "
                                                secondsText="s "
                                            />
                                        ) : (
                                            <>
                                                {data.buynow === 0 ? (
                                                    <span className="closedText">
                                                        Auction Closed
                                                    </span>
                                                ) : (
                                                    <div className="closedText"></div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : null}
                        <div className="quckBidcontain ui">
                            <div className="QuickBidContainer">
                                {isAuthenticated ? (
                                    <Bidding
                                        data={data}
                                        hideBid={1}
                                        hard="1"
                                        searchView={true}
                                        shortText="Submit Your Bid"
                                        disableReturnAssurance={true}
                                        enableNextBid={true}
                                        nextbidText={`Quick Bid ${
                                            data?.next_bid
                                                ? currencyFormat(
                                                      parseFloat(
                                                          data?.next_bid ? data?.next_bid : 0,
                                                      ).toFixed(2),
                                                  )
                                                : ''
                                        }`}
                                    />
                                ) : null}
                            </div>
                            <Bidding
                                data={data}
                                hard={'0'}
                                isBidAuctionBtn={true}
                                shortText={
                                    <>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            className="mr-2"
                                            fill={isBargainTheme ? '#fff' : '#49454f'}
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M2.30031 20.2799L11.9003 10.6799L10.5003 9.25991L9.78031 9.9699C9.6878 10.0626 9.57791 10.1362 9.45694 10.1863C9.33596 10.2365 9.20628 10.2623 9.07531 10.2623C8.94434 10.2623 8.81466 10.2365 8.69369 10.1863C8.57271 10.1362 8.46283 10.0626 8.37031 9.9699L7.66031 9.25991C7.56761 9.16739 7.49406 9.0575 7.44388 8.93653C7.3937 8.81556 7.36787 8.68587 7.36787 8.55491C7.36787 8.42394 7.3937 8.29425 7.44388 8.17328C7.49406 8.05231 7.56761 7.94242 7.66031 7.84991L13.3203 2.18991C13.4128 2.0972 13.5227 2.02365 13.6437 1.97347C13.7647 1.92329 13.8943 1.89746 14.0253 1.89746C14.1563 1.89746 14.286 1.92329 14.4069 1.97347C14.5279 2.02365 14.6378 2.0972 14.7303 2.18991L15.4403 2.89991C15.8303 3.28991 15.8303 3.91991 15.4403 4.30991L14.7303 4.99991L16.1503 6.4299C16.2428 6.3372 16.3527 6.26365 16.4737 6.21347C16.5947 6.16329 16.7243 6.13746 16.8553 6.13746C16.9863 6.13746 17.116 6.16329 17.2369 6.21347C17.3579 6.26365 17.4678 6.3372 17.5603 6.4299C17.9503 6.8199 17.9503 7.45991 17.5603 7.84991L18.9703 9.25991L19.6803 8.54991C20.0703 8.15991 20.7103 8.15991 21.1003 8.54991L21.8003 9.25991C22.1903 9.64991 22.1903 10.2899 21.8003 10.6799L16.1503 16.3299C15.7603 16.7199 15.1203 16.7199 14.7303 16.3299L14.0303 15.6299C13.9354 15.5376 13.8599 15.4273 13.8083 15.3053C13.7568 15.1834 13.7302 15.0523 13.7302 14.9199C13.7302 14.7875 13.7568 14.6565 13.8083 14.5345C13.8599 14.4125 13.9354 14.3022 14.0303 14.2099L14.7303 13.4999L13.3203 12.0899L3.71031 21.6999C3.6178 21.7926 3.50791 21.8662 3.38694 21.9163C3.26596 21.9665 3.13628 21.9923 3.00531 21.9923C2.87434 21.9923 2.74466 21.9665 2.62369 21.9163C2.50271 21.8662 2.39283 21.7926 2.30031 21.6999C1.91031 21.3099 1.91031 20.6699 2.30031 20.2799ZM20.0003 18.9999C20.5307 18.9999 21.0395 19.2106 21.4145 19.5857C21.7896 19.9608 22.0003 20.4695 22.0003 20.9999V21.9999H12.0003V20.9999C12.0003 20.4695 12.211 19.9608 12.5861 19.5857C12.9612 19.2106 13.4699 18.9999 14.0003 18.9999H20.0003Z"
                                                fill={isBargainTheme ? '#fff' : '#49454f'}
                                            />
                                        </svg>
                                        MAX BID
                                    </>
                                }
                            />
                            {/* <button className="maxBid">
                                SUBMIT MAX BID{' '}
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.30031 20.2799L11.9003 10.6799L10.5003 9.25991L9.78031 9.9699C9.6878 10.0626 9.57791 10.1362 9.45694 10.1863C9.33596 10.2365 9.20628 10.2623 9.07531 10.2623C8.94434 10.2623 8.81466 10.2365 8.69369 10.1863C8.57271 10.1362 8.46283 10.0626 8.37031 9.9699L7.66031 9.25991C7.56761 9.16739 7.49406 9.0575 7.44388 8.93653C7.3937 8.81556 7.36787 8.68587 7.36787 8.55491C7.36787 8.42394 7.3937 8.29425 7.44388 8.17328C7.49406 8.05231 7.56761 7.94242 7.66031 7.84991L13.3203 2.18991C13.4128 2.0972 13.5227 2.02365 13.6437 1.97347C13.7647 1.92329 13.8943 1.89746 14.0253 1.89746C14.1563 1.89746 14.286 1.92329 14.4069 1.97347C14.5279 2.02365 14.6378 2.0972 14.7303 2.18991L15.4403 2.89991C15.8303 3.28991 15.8303 3.91991 15.4403 4.30991L14.7303 4.99991L16.1503 6.4299C16.2428 6.3372 16.3527 6.26365 16.4737 6.21347C16.5947 6.16329 16.7243 6.13746 16.8553 6.13746C16.9863 6.13746 17.116 6.16329 17.2369 6.21347C17.3579 6.26365 17.4678 6.3372 17.5603 6.4299C17.9503 6.8199 17.9503 7.45991 17.5603 7.84991L18.9703 9.25991L19.6803 8.54991C20.0703 8.15991 20.7103 8.15991 21.1003 8.54991L21.8003 9.25991C22.1903 9.64991 22.1903 10.2899 21.8003 10.6799L16.1503 16.3299C15.7603 16.7199 15.1203 16.7199 14.7303 16.3299L14.0303 15.6299C13.9354 15.5376 13.8599 15.4273 13.8083 15.3053C13.7568 15.1834 13.7302 15.0523 13.7302 14.9199C13.7302 14.7875 13.7568 14.6565 13.8083 14.5345C13.8599 14.4125 13.9354 14.3022 14.0303 14.2099L14.7303 13.4999L13.3203 12.0899L3.71031 21.6999C3.6178 21.7926 3.50791 21.8662 3.38694 21.9163C3.26596 21.9665 3.13628 21.9923 3.00531 21.9923C2.87434 21.9923 2.74466 21.9665 2.62369 21.9163C2.50271 21.8662 2.39283 21.7926 2.30031 21.6999C1.91031 21.3099 1.91031 20.6699 2.30031 20.2799ZM20.0003 18.9999C20.5307 18.9999 21.0395 19.2106 21.4145 19.5857C21.7896 19.9608 22.0003 20.4695 22.0003 20.9999V21.9999H12.0003V20.9999C12.0003 20.4695 12.211 19.9608 12.5861 19.5857C12.9612 19.2106 13.4699 18.9999 14.0003 18.9999H20.0003Z"
                                        fill="white"
                                    />
                                </svg>
                            </button> */}
                        </div>
                    </>
                ) : checkBidShopTheme ? (
                    <>
                        {data.title !== undefined && (
                            <>
                                <h5
                                    className="name-txt cursorDecoy"
                                    onClick={() =>
                                        productViewLink
                                            ? history.push({
                                                  pathname: productViewLink,
                                              })
                                            : handleClick(data.id)
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: data.title,
                                    }}
                                />
                                {fromComponent === 'home' ? (
                                    <>
                                        {' '}
                                        {global?.storeConfigration?.remove_rating?.value != 1 ? (
                                            <div className={'ratingLiqThree' + ' ' + reviewId}>
                                                <div
                                                    className="gvRating"
                                                    onClick={() => {
                                                        showReview()
                                                    }}
                                                >
                                                    <Rating
                                                        name="read-only"
                                                        value={
                                                            data?.auctionnotes
                                                                ?.trim()
                                                                .toLowerCase()
                                                                .includes('new')
                                                                ? 5
                                                                : data?.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('open')
                                                                ? 4.5
                                                                : data?.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('damage')
                                                                ? 3.5
                                                                : 2.5
                                                        }
                                                        precision={0.5}
                                                        readOnly
                                                    />
                                                </div>

                                                {reviewId ? (
                                                    <>
                                                        <div className="fiveStar"></div>
                                                        <p className="fiveStarText">
                                                            {data?.auctionnotes
                                                                ?.trim()
                                                                .toLowerCase()
                                                                .includes('new')
                                                                ? "These items are rated 5 stars and are brand new. They represent the pinnacle of quality, with no flaws or imperfections. Purchase with absolute confidence, knowing you're receiving the highest standard of excellence."
                                                                : data.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('open')
                                                                ? "These items are rated 4.5 stars and are in open box condition. While they have been opened, they are still in excellent condition with minimal signs of use. Rest assured, you're getting high-quality content with just a touch of prior handling."
                                                                : data.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('damage')
                                                                ? "These Items are rated 3.5 stars and are in damaged condition. While it may not meet retail standards, it's not in such poor condition that it's only suitable for parts. This item might have been used or could be missing its packaging."
                                                                : "These Items are rated 2.5 stars and with additional imperfections, please consult the accompanying notes for detailed insights into their condition. Our aim is to provide transparency, ensuring you're fully informed before making a decision."}
                                                        </p>
                                                        <div className="">
                                                            <PrimaryButton
                                                                label={'OK'}
                                                                onClick={() => {
                                                                    setReviewId('')
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </>
                                ) : (
                                    <div className="gvRatingDetails">
                                        {global?.storeConfigration?.remove_rating?.value != 1 ? (
                                            <div className={'ratingLiqThree' + ' ' + reviewId}>
                                                <div
                                                    className="gvRating"
                                                    onClick={() => {
                                                        showReview()
                                                    }}
                                                >
                                                    <Rating
                                                        name="read-only"
                                                        value={
                                                            data?.auctionnotes
                                                                ?.trim()
                                                                .toLowerCase()
                                                                .includes('new')
                                                                ? 5
                                                                : data?.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('open')
                                                                ? 4.5
                                                                : data?.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('damage')
                                                                ? 3.5
                                                                : 2.5
                                                        }
                                                        precision={0.5}
                                                        readOnly
                                                    />
                                                </div>

                                                {reviewId ? (
                                                    <>
                                                        <div className="fiveStar"></div>
                                                        <p className="fiveStarText">
                                                            {data?.auctionnotes
                                                                ?.trim()
                                                                .toLowerCase()
                                                                .includes('new')
                                                                ? "These items are rated 5 stars and are brand new. They represent the pinnacle of quality, with no flaws or imperfections. Purchase with absolute confidence, knowing you're receiving the highest standard of excellence."
                                                                : data.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('open')
                                                                ? "These items are rated 4.5 stars and are in open box condition. While they have been opened, they are still in excellent condition with minimal signs of use. Rest assured, you're getting high-quality content with just a touch of prior handling."
                                                                : data.auctionnotes
                                                                      ?.trim()
                                                                      .toLowerCase()
                                                                      .includes('damage')
                                                                ? "These Items are rated 3.5 stars and are in damaged condition. While it may not meet retail standards, it's not in such poor condition that it's only suitable for parts. This item might have been used or could be missing its packaging."
                                                                : "These Items are rated 2.5 stars and with additional imperfections, please consult the accompanying notes for detailed insights into their condition. Our aim is to provide transparency, ensuring you're fully informed before making a decision."}
                                                        </p>
                                                        <div className="">
                                                            <PrimaryButton
                                                                label={'OK'}
                                                                onClick={() => {
                                                                    setReviewId('')
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        <h6 className="galleryPrice condition">
                                            <span className="ratingDot"></span>
                                            <span>Condition:</span>
                                            <span
                                                className={`prcTxtVal`}
                                                title={data.auctionnotes ? data.auctionnotes : '-'}
                                            >
                                                {data.auctionnotes ? data.auctionnotes : '-'}
                                            </span>
                                        </h6>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between mt-2 shiftInNew">
                                    <div>
                                        <h6
                                            className={`galleryPrice actnPriceVlue ${reviewId} nowrap d-flex 1`}
                                        >
                                            {checkBidShopTheme && data.auction == 0 && (
                                                <>
                                                    <span className="showSrch">
                                                        {data.market_status == 'sold'
                                                            ? 'Sold'
                                                            : 'Buy Now'}{' '}
                                                        Price:
                                                    </span>
                                                    <span className="prcTxtVal showSrch">
                                                        {currencyFormat(
                                                            parseFloat(data.bprice).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.bprice}
                                                        />
                                                    </span>
                                                </>
                                            )}
                                            {(data.auction && data.wprice) ||
                                            (fromComponent == 'home' &&
                                                !(checkBidShopTheme && data.auction == 0)) ? (
                                                <>
                                                    {data.market_status == 'closed' ? (
                                                        <span>UnSold</span>
                                                    ) : (
                                                        <>
                                                            {global.pluginConfiguration
                                                                ?.reverse_auction?.enable &&
                                                            parseInt(data.content_head5) == 1 ? (
                                                                <span>
                                                                    {data.market_status == 'sold'
                                                                        ? 'Sold'
                                                                        : 'Start'}{' '}
                                                                    Price
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    {data.market_status == 'sold'
                                                                        ? data.nobids ||
                                                                          fromComponent == 'home'
                                                                            ? 'Sold'
                                                                            : 'Start'
                                                                        : data.nobids ||
                                                                          data.bid_count
                                                                        ? 'Current'
                                                                        : 'Start'}{' '}
                                                                    Price
                                                                </span>
                                                            )}

                                                            <span className="prcTxtVal">
                                                                {currencyFormat(
                                                                    parseFloat(
                                                                        data.wprice
                                                                            ? data.wprice
                                                                            : data.bprice,
                                                                    ).toFixed(2),
                                                                    currencyType,
                                                                )}
                                                                <CurrencyConverterFormat
                                                                    amount={data.wprice}
                                                                />
                                                            </span>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {' '}
                                                    {data.market_status == 'closed' ? (
                                                        <span>UnSold</span>
                                                    ) : (
                                                        <>
                                                            {data.auction ? (
                                                                <span className="crncyNtAvlblVlue">
                                                                    <span>
                                                                        {data.market_status ==
                                                                        'sold'
                                                                            ? 'Sold'
                                                                            : parseInt(
                                                                                  data.wprice,
                                                                              ) ===
                                                                              parseInt(data.sprice)
                                                                            ? 'Start'
                                                                            : 'Current'}
                                                                        Price:
                                                                    </span>
                                                                    {data.buynow && data.bprice ? (
                                                                        <span className="prcTxtVal">
                                                                            {currencyFormat(
                                                                                parseFloat(
                                                                                    data.bprice,
                                                                                ).toFixed(2),
                                                                                currencyType,
                                                                            )}
                                                                            <CurrencyConverterFormat
                                                                                amount={data.bprice}
                                                                            />
                                                                        </span>
                                                                    ) : (
                                                                        <span className="gridNotAvailable">
                                                                            Not Available
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </h6>
                                    </div>
                                    <div className="newShift text-right">
                                        {fromComponent === 'home' ? (
                                            <>
                                                {checkBidShopTheme && (
                                                    <span className="percentOff">
                                                        {(() => {
                                                            const m = parseFloat(data.mprice)
                                                            const b = parseFloat(data.bprice)
                                                            if (
                                                                !data.mprice ||
                                                                isNaN(m) ||
                                                                m <= 0 ||
                                                                isNaN(b) ||
                                                                b < 0
                                                            ) {
                                                                return ''
                                                            }
                                                            if (b >= m) {
                                                                return ''
                                                            }
                                                            let discount = ((m - b) / m) * 100
                                                            discount = Math.min(
                                                                99,
                                                                Math.round(discount),
                                                            )
                                                            if (discount <= 0) {
                                                                return ''
                                                            }
                                                            return `${discount}% OFF`
                                                        })()}
                                                    </span>
                                                )}
                                                <div className="pickUpOnly fromSearchPickuP">
                                                    (Retail{' '}
                                                    {currencyFormat(
                                                        parseFloat(data.mprice || 0).toFixed(2),
                                                        currencyType,
                                                    )}
                                                    <CurrencyConverterFormat amount={data.mprice} />
                                                    )
                                                </div>
                                                <Tooltip
                                                    title={
                                                        <h6 className="galleryPrice condition">
                                                            <span className="mb-2">Condition:</span>
                                                            <br />
                                                            <span
                                                                className={`prcTxtVal`}
                                                                title={
                                                                    data.auctionnotes
                                                                        ? data.auctionnotes
                                                                        : '-'
                                                                }
                                                            >
                                                                {data.auctionnotes
                                                                    ? data.auctionnotes
                                                                    : '-'}
                                                            </span>
                                                        </h6>
                                                    }
                                                >
                                                    <p className="lotInsights d-flex align-items-center">
                                                        <InfoOutlined /> See Lot Insights
                                                    </p>
                                                </Tooltip>
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    className="d-flex align-items-center flex-wrap justify-content-end"
                                                    style={{ gap: '7px' }}
                                                >
                                                    {checkBidShopTheme && (
                                                        <span className="percentOff">
                                                            {(() => {
                                                                const m = parseFloat(data.mprice)
                                                                const b = parseFloat(data.bprice)
                                                                if (
                                                                    !data.mprice ||
                                                                    isNaN(m) ||
                                                                    m <= 0 ||
                                                                    isNaN(b) ||
                                                                    b < 0
                                                                ) {
                                                                    return ''
                                                                }
                                                                if (b >= m) {
                                                                    return ''
                                                                }
                                                                let discount = ((m - b) / m) * 100
                                                                discount = Math.min(
                                                                    99,
                                                                    Math.round(discount),
                                                                )
                                                                if (discount <= 0) {
                                                                    return ''
                                                                }
                                                                return `${discount}% OFF`
                                                            })()}
                                                        </span>
                                                    )}
                                                    <div className="pickUpOnly fromSearchPickuP mb-0">
                                                        (Retail{' '}
                                                        {currencyFormat(
                                                            parseFloat(data.mprice || 0).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.mprice}
                                                        />
                                                        )
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <div className="pickUpOnly">
                                            <LocalShippingOutlined /> Pick up only
                                        </div>
                                    </div>
                                </div>
                                {data.auction == 0 && data.buynow == 1 ? null : (
                                    <div className="d-flex justify-content-between mt-3 endPart">
                                        <span
                                            className="bidsCount"
                                            onClick={(e) => {
                                                handleBidHistoryModal(data)
                                            }}
                                        >
                                            {data.nobids || data.bid_count || 0} Bids
                                        </span>
                                        <Tooltip
                                            title={
                                                data.auction == 1 &&
                                                type != 'buynow' && (
                                                    <div className="text-center endDteTxt">
                                                        {data.market_status === 'open' ? (
                                                            <>
                                                                {cardTheme == 'liquidationTwo' ? (
                                                                    <p className="mb-0">
                                                                        Ends{' '}
                                                                        {`${moment(data.date_closed)
                                                                            .tz(
                                                                                global
                                                                                    ?.storeConfigration
                                                                                    ?.auction_view_time_zone
                                                                                    ?.value
                                                                                    ? global
                                                                                          ?.storeConfigration
                                                                                          ?.auction_view_time_zone
                                                                                          ?.value
                                                                                    : moment.tz.guess(),
                                                                            )
                                                                            .format(
                                                                                'MMM Do',
                                                                            )}, ${moment(
                                                                            data.date_closed,
                                                                        )
                                                                            .tz(
                                                                                global
                                                                                    ?.storeConfigration
                                                                                    ?.auction_view_time_zone
                                                                                    ?.value
                                                                                    ? global
                                                                                          ?.storeConfigration
                                                                                          ?.auction_view_time_zone
                                                                                          ?.value
                                                                                    : moment.tz.guess(),
                                                                            )
                                                                            .format('h:mm a')}`}
                                                                    </p>
                                                                ) : (
                                                                    <p className="mb-0">
                                                                        Ends{' '}
                                                                        {dateFormatFront(
                                                                            data.date_closed,
                                                                        )}
                                                                    </p>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <p className="mb-0">Auction Closed</p>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        >
                                            {!noTimer && data.date_closed && (
                                                <div
                                                    className={`gcTimer primeTmCrd ${reviewId} hoTimer ${
                                                        data.buynow === 1 && data.auction === 0
                                                            ? 'noBackDrop'
                                                            : ''
                                                    }`}
                                                >
                                                    {(data.market_status === 'open' &&
                                                        data.auction) ||
                                                    (data.market_status === 'open' &&
                                                        auction_and_buynow) ? (
                                                        <Timer
                                                            date_added={data.date_added}
                                                            date_closed={data.date_closed}
                                                            withText={1}
                                                            endText={'Ends in' + ': '}
                                                            startText={'Starts in' + ': '}
                                                            theme={timerTheme}
                                                            // icon={timerIcon}
                                                            audio={audio}
                                                            product_id={data.id}
                                                            viewProduct={viewProduct}
                                                            setViewProduct={setViewProduct}
                                                        />
                                                    ) : (
                                                        <>
                                                            {data.buynow === 0 ? (
                                                                <span className="closedText">
                                                                    Auction Closed
                                                                </span>
                                                            ) : (
                                                                <div className="closedText">
                                                                    Auction Closed
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </Tooltip>
                                    </div>
                                )}

                                {fromComponent !== 'home' && (
                                    <>
                                        {data.auction &&
                                        !window.location.pathname.includes('gallery') &&
                                        (type !== 'buynow' || checkBidShopTheme) ? (
                                            <>
                                                <div
                                                    className={`gpBidCart mt-2 ${reviewId} ${
                                                        data.market_status === 'sold'
                                                            ? 'd-none'
                                                            : ''
                                                    }`}
                                                >
                                                    <Bidding
                                                        theme="multiseller"
                                                        data={data}
                                                        hard={
                                                            global.storeConfigration?.hard_bid
                                                                ?.value || '1'
                                                        }
                                                        shortText={bidBtnLabel}
                                                        isWizardBtn={isWizardTheme}
                                                        buyerAssuranceNew={isWizardTheme}
                                                        removePopup={removePopup}
                                                        detailsAuction={details}
                                                    />
                                                    {type == 'buynow' && type != 'Auction'
                                                        ? ''
                                                        : isAuthenticated &&
                                                          cardTheme != 'liquidationTwo' &&
                                                          ((parseInt(data.buynow) == 1 &&
                                                              parseInt(data.auction) == 0) ||
                                                              (parseInt(data.wprice) <=
                                                                  parseInt(data.bprice) &&
                                                                  parseInt(data.buynow) == 1 &&
                                                                  parseInt(data.auction) == 1)) &&
                                                          data.market_status == 'open' && (
                                                              <Button
                                                                  className={`cartBtn ${
                                                                      active ? 'active' : ''
                                                                  }`}
                                                                  onClick={() =>
                                                                      handleCart(
                                                                          data.id,
                                                                          data?.date_added,
                                                                      )
                                                                  }
                                                                  disabled={data.buynow == 0}
                                                              >
                                                                  <span className="material-icons-outlined">
                                                                      {active
                                                                          ? 'shopping_cart_checkout'
                                                                          : 'add_shopping_cart'}
                                                                  </span>
                                                              </Button>
                                                          )}
                                                </div>
                                                {cardTheme == 'liquidationTwo' ? (
                                                    <>
                                                        {type == 'buynow' &&
                                                        type != 'Auction' &&
                                                        !checkBidShopTheme ? (
                                                            <div
                                                                className={`gpBidCart spByNw`}
                                                            ></div>
                                                        ) : ((parseInt(data.buynow) == 1 &&
                                                              parseInt(data.auction) == 0) ||
                                                              (parseInt(data.wprice) <=
                                                                  parseInt(data.bprice) &&
                                                                  parseInt(data.buynow) == 1 &&
                                                                  parseInt(data.auction) == 1)) &&
                                                          data.market_status == 'open' ? (
                                                            <div className="gpBidCart spByNw">
                                                                {isAuthenticated ? (
                                                                    <PrimaryButton
                                                                        btnSize={'small'}
                                                                        onClick={() =>
                                                                            handleCart(
                                                                                data.id,
                                                                                data?.date_added,
                                                                            )
                                                                        }
                                                                        disabled={data.buynow == 0}
                                                                        label={
                                                                            active === true
                                                                                ? 'Added to Cart'
                                                                                : cardTheme !==
                                                                                  'auctioneer'
                                                                                ? `Buy it Now: ${currencyFormat(
                                                                                      data.bprice,
                                                                                  )}`
                                                                                : 'Add to Cart'
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <PrimaryButton
                                                                        btnSize={'small'}
                                                                        onClick={() =>
                                                                            handleRedirectInternal(
                                                                                history,
                                                                                'login',
                                                                            )
                                                                        }
                                                                        disabled={data.buynow == 0}
                                                                        label={`Login To Buy: ${currencyFormat(
                                                                            data.bprice,
                                                                        )}`}
                                                                    />
                                                                )}
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        ) : data.market_status !== 'sold' ? (
                                            <>
                                                {cardTheme === 'liquidationTwo' &&
                                                    type == 'buynow' &&
                                                    type != 'Auction' && (
                                                        <div className="noBidAboveDiv"></div>
                                                    )}

                                                {parseInt(data.bprice) <
                                                parseInt(data.wprice) ? null : isAuthenticated ||
                                                  global?.storeConfigration?.guest_user_login
                                                      ?.value ? (
                                                    <div className="gpBidCart single">
                                                        <PrimaryButton
                                                            btnSize={
                                                                cardTheme === 'liquidationTwo'
                                                                    ? 'small'
                                                                    : ''
                                                            }
                                                            onClick={() =>
                                                                handleCart(
                                                                    data.id,
                                                                    data?.date_added,
                                                                )
                                                            }
                                                        >
                                                            {active === true
                                                                ? 'Added to Cart'
                                                                : cardTheme !== 'auctioneer'
                                                                ? `Buy it Now: ${currencyFormat(
                                                                      data.bprice,
                                                                  )}`
                                                                : 'Add to Cart'}
                                                        </PrimaryButton>
                                                    </div>
                                                ) : (
                                                    <div className="gpBidCart single">
                                                        <PrimaryButton
                                                            btnSize={
                                                                cardTheme === 'liquidationTwo'
                                                                    ? 'small'
                                                                    : ''
                                                            }
                                                            onClick={() =>
                                                                handleRedirectInternal(
                                                                    history,
                                                                    'login',
                                                                )
                                                            }
                                                        >
                                                            {`Login To Buy: ${currencyFormat(
                                                                data.bprice,
                                                            )}`}
                                                        </PrimaryButton>
                                                    </div>
                                                )}
                                                {cardTheme === 'liquidationTwo' &&
                                                    type == 'buynow' &&
                                                    type != 'Auction' && (
                                                        <div className="text-center endDteTxt noBidDownDiv"></div>
                                                    )}

                                                {/* {!isAuthenticated && (
                                                <>
                                                    {cardTheme === 'liquidationTwo' &&
                                                        type == 'buynow' &&
                                                        type != 'Auction' && (
                                                            <div className="noBidDiv"></div>
                                                        )}
                                                </>
                                            )} */}
                                            </>
                                        ) : null}
                                    </>
                                )}
                            </>
                        )}{' '}
                    </>
                ) : (
                    <>
                        {data.title !== undefined && (
                            <>
                                {cardTheme !== 'liquidationTwo' &&
                                    cardTheme !== 'carAuction' &&
                                    cardTheme !== 'auctioneer' && (
                                        <>
                                            {global.storeConfigration?.disable_hosted_by?.value !=
                                                1 && data.seller_name ? (
                                                <h5 className="hostedBy condition executed">
                                                    Hosted By: {sellerNameFormat(data.seller_name)}
                                                </h5>
                                            ) : null}
                                        </>
                                    )}
                                {isPrimeBidsTheme ? (
                                    <div className="cardCount">
                                        {parseInt(data?.auction) == 1 ? (
                                            <>{data?.nobids} Bids | </>
                                        ) : null}
                                        {data?.watchlist_count !== '' &&
                                        data?.watchlist_count !== null &&
                                        data?.watchlist_count !== undefined
                                            ? data?.watchlist_count
                                            : 0}{' '}
                                        Watchers | {data?.most_viewed || data?.viewers || 25}{' '}
                                        Viewers
                                    </div>
                                ) : null}
                                {global?.storeConfigration?.lot_sequence_order?.value == 1 ? (
                                    <p className="gpAddnInfo">
                                        Lot #: <span>{data?.deed_document || '-'}</span>
                                    </p>
                                ) : (
                                    <p className="gpAddnInfo">
                                        Lot Number:{' '}
                                        <span>
                                            {data?.lot_number !== '' ? data.lot_number : '-'}
                                        </span>
                                    </p>
                                )}
                                <h5
                                    className="name-txt cursorDecoy"
                                    onClick={() =>
                                        cardTheme === 'carAuction'
                                            ? history.push({
                                                  pathname: `/productView/${data.id}`,
                                                  state: { lotid: lotDetails },
                                              })
                                            : isWizardTheme
                                            ? hanlderedirection(data.id)
                                            : productViewLink
                                            ? history.push({
                                                  pathname: productViewLink,
                                              })
                                            : handleClick(data.id)
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            cardTheme == 'auctioneer' &&
                                            data.category_id !=
                                                global?.storeConfigration?.similar_category?.value
                                                ? `${
                                                      data.custom_field_9 &&
                                                      data.custom_field_9.includes('}')
                                                          ? JSON.parse(data.custom_field_9)
                                                                ?.game_theme
                                                          : ''
                                                  } ${data.subcategory
                                                      ?.split(',')
                                                      ?.map(
                                                          (val) =>
                                                              categoryTypes[val]?.description ?? '',
                                                      )
                                                      ?.join(', ')}`
                                                : data.bundle_id
                                                ? data.bundle_name
                                                : data.title,
                                    }}
                                />
                                {global?.storeConfigration?.remove_rating?.value != 1 ? (
                                    <div className={'ratingLiqThree' + ' ' + reviewId}>
                                        <div
                                            className="gvRating"
                                            onClick={() => {
                                                showReview()
                                            }}
                                        >
                                            <Rating
                                                name="read-only"
                                                value={
                                                    data?.auctionnotes
                                                        ?.trim()
                                                        .toLowerCase()
                                                        .includes('new')
                                                        ? 5
                                                        : data?.auctionnotes
                                                              ?.trim()
                                                              .toLowerCase()
                                                              .includes('open')
                                                        ? 4.5
                                                        : data?.auctionnotes
                                                              ?.trim()
                                                              .toLowerCase()
                                                              .includes('damage')
                                                        ? 3.5
                                                        : 2.5
                                                }
                                                precision={0.5}
                                                readOnly
                                            />
                                        </div>

                                        {reviewId ? (
                                            <>
                                                <div className="fiveStar"></div>
                                                <p className="fiveStarText">
                                                    {data?.auctionnotes
                                                        ?.trim()
                                                        .toLowerCase()
                                                        .includes('new')
                                                        ? "These items are rated 5 stars and are brand new. They represent the pinnacle of quality, with no flaws or imperfections. Purchase with absolute confidence, knowing you're receiving the highest standard of excellence."
                                                        : data.auctionnotes
                                                              ?.trim()
                                                              .toLowerCase()
                                                              .includes('open')
                                                        ? "These items are rated 4.5 stars and are in open box condition. While they have been opened, they are still in excellent condition with minimal signs of use. Rest assured, you're getting high-quality content with just a touch of prior handling."
                                                        : data.auctionnotes
                                                              ?.trim()
                                                              .toLowerCase()
                                                              .includes('damage')
                                                        ? "These Items are rated 3.5 stars and are in damaged condition. While it may not meet retail standards, it's not in such poor condition that it's only suitable for parts. This item might have been used or could be missing its packaging."
                                                        : "These Items are rated 2.5 stars and with additional imperfections, please consult the accompanying notes for detailed insights into their condition. Our aim is to provide transparency, ensuring you're fully informed before making a decision."}
                                                </p>
                                                <div className="">
                                                    <PrimaryButton
                                                        label={'OK'}
                                                        onClick={() => {
                                                            setReviewId('')
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        ) : null}
                                    </div>
                                ) : (
                                    ''
                                )}

                                {global.storeConfigration?.show_condition?.value == 1 &&
                                global.storeDetails?.theme === 18 &&
                                global?.storeConfigration?.remove_rating?.value != 1 ? (
                                    <h6 className="galleryPrice condition newCond">
                                        {/* <span>Condition: </span> */}
                                        <span
                                            className={`prcTxtVal `}
                                            title={data.auctionnotes ? data.auctionnotes : '-'}
                                        >
                                            {data.auctionnotes ? data.auctionnotes : '-'}
                                        </span>
                                    </h6>
                                ) : null}
                                {/* <div className="conditionLiq">
                                    <p
                                        className={`m-0 cursorDecoy ${
                                            data.condition_field?.includes('Used - Like New')
                                                ? 'text-primary'
                                                : data.condition_field?.includes('New')
                                                ? 'text-success'
                                                : 'text-danger'
                                        }`}
                                    >
                                        {data.condition_field || ''}
                                    </p>
                                </div> */}
                                {cardTheme == 'auctioneer' && (
                                    <>
                                        {global.storeConfigration?.disable_hosted_by?.value != 1 ? (
                                            <h5 className="ref-text">
                                                {data.title} Refurbished{' '}
                                                {data.subcategory
                                                    ?.split(',')
                                                    ?.map(
                                                        (val) =>
                                                            categoryTypes[val]?.description ?? '',
                                                    )
                                                    ?.join(', ')}{' '}
                                                Machine
                                            </h5>
                                        ) : null}
                                    </>
                                )}
                                {showEstimate === true &&
                                    (parseInt(data.lowest) > 0 || parseInt(data.highest) > 0) && (
                                        <p>
                                            Est:{' '}
                                            <span>
                                                {currencyFormat(data.lowest)} -{' '}
                                                {currencyFormat(data.highest)}
                                            </span>
                                        </p>
                                    )}
                                {cardTheme !== 'liquidationTwo' && (
                                    <>
                                        {global.storeConfigration?.enable_city?.value == 1 &&
                                        data.product_city ? (
                                            <h5 className="hostedBy">{data.product_city}</h5>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                                {cardTheme === 'liquidationTwo' &&
                                (global.storeConfigration?.condition_field?.value == 1 ||
                                    global.storeConfigration?.damaged_field?.value == 1 ||
                                    global.storeConfigration?.functional_field?.value == 1 ||
                                    global.storeConfigration?.missing_parts_field?.value == 1) ? (
                                    <div className="pdtStsInfo">
                                        <ul>
                                            <li>
                                                <label>Condition:</label>
                                                <Tooltip
                                                    title={data.condition_field || '-'}
                                                    arrow
                                                    placement="top"
                                                >
                                                    <p
                                                        className={`m-0 cursorDecoy ${
                                                            data.condition_field?.includes(
                                                                'Used - Like New',
                                                            )
                                                                ? 'text-primary'
                                                                : data.condition_field?.includes(
                                                                      'New',
                                                                  )
                                                                ? 'text-success'
                                                                : 'text-danger'
                                                        }`}
                                                    >
                                                        {data.condition_field || '-'}
                                                    </p>
                                                </Tooltip>
                                            </li>

                                            <li>
                                                <label>Functional:</label>
                                                <p
                                                    className={`m-0 ${
                                                        data.functional_field?.includes('Yes')
                                                            ? 'text-success'
                                                            : 'text-danger'
                                                    }`}
                                                >
                                                    {data.functional_field || '-'}
                                                </p>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <label>Damaged:</label>
                                                <p
                                                    className={`m-0 ${
                                                        data.damaged_field?.includes('No')
                                                            ? 'text-success'
                                                            : 'text-danger'
                                                    }`}
                                                >
                                                    {data.damaged_field || '-'}
                                                </p>
                                            </li>

                                            <li>
                                                <label>Missing Parts:</label>
                                                <p
                                                    className={`m-0 ${
                                                        data.missing_parts_field?.includes('Yes')
                                                            ? 'text-danger'
                                                            : 'text-success'
                                                    }`}
                                                >
                                                    {data.missing_parts_field || '-'}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                ) : null}
                                {showCondition ? (
                                    <p className="gpAddnInfo">
                                        Condition:{' '}
                                        {cardTheme == 'auctioneer' ? (
                                            <span
                                                className={`${
                                                    data.auctionnotes
                                                        ?.trim()
                                                        ?.toLowerCase()
                                                        ?.includes('new')
                                                        ? 'text-success'
                                                        : data.auctionnotes
                                                              ?.trim()
                                                              ?.toLowerCase()
                                                              ?.includes('open box')
                                                        ? 'text-primary'
                                                        : data.auctionnotes
                                                              ?.trim()
                                                              ?.toLowerCase()
                                                              ?.includes('damage')
                                                        ? 'text-danger'
                                                        : ''
                                                }`}
                                            >
                                                {data?.auctionnotes}
                                            </span>
                                        ) : (
                                            <span>
                                                {data?.conditionunique
                                                    ? allCondition
                                                          .filter(
                                                              (condition) =>
                                                                  condition.id ==
                                                                  data.conditionunique,
                                                          )
                                                          .map((d) => d.description)
                                                    : '--'}
                                            </span>
                                        )}
                                    </p>
                                ) : (
                                    ''
                                )}
                                {/* Write Optimized code for this and uncomment */}
                                {/* {showLocation ? (
                                    <p className="gpAddnInfo">
                                        Location:{' '}
                                        <span>
                                            {data?.location
                                                ? countryList
                                                      .filter(
                                                          (country) =>
                                                              country.location_id == data.location,
                                                      )
                                                      .map((d) => d.name)
                                                : '--'}
                                        </span>
                                    </p>
                                ) : (
                                    ''
                                )} */}
                                {cardTheme !== 'carAuction' &&
                                global.storeDetails?.theme !== 18 &&
                                !isWizardTheme ? (
                                    <>
                                        {!noTimer && data.date_closed && (
                                            <div
                                                className={`gcTimer primeTmCrd ${reviewId} hoTimer ${
                                                    data.buynow === 1 && data.auction === 0
                                                        ? 'noBackDrop'
                                                        : ''
                                                }`}
                                            >
                                                {/*eslint-disable*/}
                                                {(data.market_status === 'open' && data.auction) ||
                                                (data.market_status === 'open' &&
                                                    auction_and_buynow) ? (
                                                    <Timer
                                                        date_added={data.date_added}
                                                        date_closed={data.date_closed}
                                                        withText={1}
                                                        endText={'Time left' + ': '}
                                                        startText={'Starts in' + ': '}
                                                        theme={timerTheme}
                                                        icon={timerIcon}
                                                        audio={audio}
                                                        product_id={data.id}
                                                        viewProduct={viewProduct}
                                                        setViewProduct={setViewProduct}
                                                    />
                                                ) : (
                                                    <>
                                                        {data.buynow === 0 ? (
                                                            <span className="closedText">
                                                                Auction Closed
                                                            </span>
                                                        ) : (
                                                            <div className="closedText"></div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    ''
                                )}
                            </>
                        )}
                        {cardTheme == 'HeavyEquipment' ? (
                            <div className="gaInfo">
                                {fromSearch ? (
                                    <h6>Lot ID: {data.category_id}</h6>
                                ) : (
                                    <h6>Auction ID: {data.id}</h6>
                                )}
                                {(data.buynow == 0 && data.auction == 1) ||
                                (data.buynow == 1 && data.auction == 1) ? (
                                    <>
                                        <p>
                                            <span>Start Date:</span>
                                            {moment(data.date_added)
                                                .tz('America/New_York')
                                                .format('MMM Do YYYY, h:mm a')}
                                        </p>
                                        <p>
                                            <span>End Date:</span>
                                            {moment(data.date_closed)
                                                .tz('America/New_York')
                                                .format('MMM Do YYYY, h:mm a')}
                                        </p>
                                    </>
                                ) : (
                                    ''
                                )}
                                <p
                                    className="gaDesc"
                                    dangerouslySetInnerHTML={{
                                        __html: data.description,
                                    }}
                                ></p>
                            </div>
                        ) : cardTheme == 'carAuction' ? (
                            <div className="autoGridInfo mb-3">
                                {type !== 'buynow' && (
                                    <h6 className="crncyValue">
                                        <span className="material-icons-outlined">
                                            monetization_on
                                        </span>
                                        {data.auction &&
                                            data.wprice &&
                                            currencyFormat(
                                                parseFloat(data.wprice).toFixed(2),
                                                currencyType,
                                            )}
                                        <CurrencyConverterFormat amount={data.wprice} />
                                    </h6>
                                )}
                                {data.buynow == 1 && type == 'buynow' && (
                                    <h6 className="crncyValue">
                                        <span className="material-icons-outlined">
                                            monetization_on
                                        </span>
                                        {data.buynow &&
                                            data.bprice &&
                                            currencyFormat(
                                                parseFloat(data.bprice).toFixed(2),
                                                currencyType,
                                            )}
                                        <CurrencyConverterFormat amount={data.bprice} />
                                    </h6>
                                )}

                                {!noTimer && data.market_status === 'open' && data.auction ? (
                                    <div className="timrVlue">
                                        <span className="material-icons-outlined">watch_later</span>
                                        <Timer
                                            date_added={data.date_added}
                                            date_closed={data.date_closed}
                                            withText={1}
                                            endText={'Time left' + ': '}
                                            startText={'Starts in' + ': '}
                                            theme={timerTheme}
                                            audio={audio}
                                        />
                                    </div>
                                ) : (
                                    <>
                                        {data.buynow === 0 ? (
                                            <span className="closedText">Auction Closed</span>
                                        ) : (
                                            ''
                                        )}
                                    </>
                                )}
                            </div>
                        ) : cardTheme == 'liquidationTwo' ? (
                            <>
                                {!isWizardTheme ? (
                                    <>
                                        {data.mprice ? (
                                            <h6 className={`galleryPrice rtlrPrice ${reviewId}`}>
                                                <span className="prcLabel">
                                                    Retail Price:{' '}
                                                    {checkEmursTheme ? null : (
                                                        <>
                                                            {' '}
                                                            {data.retailer_link ? (
                                                                <a
                                                                    href={data.retailer_link}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    (Retailer)
                                                                </a>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </span>
                                                <span className="prcTxtVal">
                                                    {currencyFormat(
                                                        parseFloat(data.mprice || 0).toFixed(2),
                                                        checkEmursTheme
                                                            ? data.mprice
                                                            : currencyType,
                                                    )}
                                                    <CurrencyConverterFormat amount={data.mprice} />
                                                </span>
                                            </h6>
                                        ) : (
                                            <h6 className=""></h6>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {data.market_status === 'closed' ||
                                        data.market_status === 'sold' ? (
                                            ''
                                        ) : (
                                            <div
                                                className={`d-flex align-items-center justify-content-around  ${
                                                    isWizardTheme && isAuthenticated
                                                        ? 'authWizardCardBody'
                                                        : null
                                                }`}
                                            >
                                                <h6
                                                    className={`galleryPrice rtlrPrice wizardGalleryPrice ${reviewId}`}
                                                >
                                                    <span className="prcLabel">
                                                        Suggested Retail
                                                        {/* {data.retailer_link ? (
                                                    <a href={data.retailer_link} target="_blank">
                                                        (Retailer)
                                                    </a>
                                                ) : null} */}
                                                    </span>
                                                    <span className="prcTxtVal">
                                                        {currencyFormat(
                                                            parseFloat(data.mprice || 0).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.mprice}
                                                        />
                                                    </span>
                                                </h6>
                                                <h6 className="galleryPrice condition wizardGalleryCondition align-items-center">
                                                    {data.auctionnotes ? (
                                                        <>
                                                            <img src="/assets/images/wizardAuctions/OpenBoxImg.svg" />
                                                            <Tooltip title={conditionTooltip}>
                                                                <span
                                                                    className={`prcTxtVal ${
                                                                        data.auctionnotes
                                                                            ?.trim()
                                                                            ?.toLowerCase()
                                                                            ?.includes('new')
                                                                            ? 'text-success'
                                                                            : data.auctionnotes
                                                                                  ?.trim()
                                                                                  ?.toLowerCase()
                                                                                  ?.includes(
                                                                                      'excellent',
                                                                                  )
                                                                            ? 'text-excellent'
                                                                            : data.auctionnotes
                                                                                  ?.trim()
                                                                                  ?.toLowerCase()
                                                                                  ?.includes(
                                                                                      'open box',
                                                                                  )
                                                                            ? 'text-primary'
                                                                            : data.auctionnotes
                                                                                  ?.trim()
                                                                                  ?.toLowerCase()
                                                                                  ?.includes(
                                                                                      'damage',
                                                                                  )
                                                                            ? 'text-danger'
                                                                            : ''
                                                                    }`}
                                                                    title={
                                                                        data.auctionnotes
                                                                            ? data.auctionnotes
                                                                            : '-'
                                                                    }
                                                                >
                                                                    {data.auctionnotes
                                                                        ? data.auctionnotes
                                                                        : '-'}
                                                                </span>
                                                            </Tooltip>
                                                        </>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </h6>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        ) : null}
                        {cardTheme == 'liquidation' ? (
                            <h6 className="galleryPrice condition">
                                <span>Condition:</span>
                                <span
                                    className={`prcTxtVal`}
                                    title={data.auctionnotes ? data.auctionnotes : '-'}
                                >
                                    {data.auctionnotes ? data.auctionnotes : '-'}
                                </span>
                            </h6>
                        ) : (
                            ''
                        )}
                        {type !== 'buynow' && (
                            <>
                                {!isWizardTheme ? (
                                    <h6
                                        className={`galleryPrice actnPriceVlue ${reviewId} nowrap d-flex 1`}
                                    >
                                        {(data.auction && data.wprice) ||
                                        fromComponent == 'home' ? (
                                            <>
                                                {data.market_status == 'closed' ? (
                                                    <span>UnSold</span>
                                                ) : (
                                                    <>
                                                        {global.pluginConfiguration?.reverse_auction
                                                            ?.enable &&
                                                        parseInt(data.content_head5) == 1 ? (
                                                            <span>
                                                                {data.market_status == 'sold'
                                                                    ? 'Sold'
                                                                    : 'Start'}{' '}
                                                                Price{!isWizardTheme && ':'}{' '}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {data.market_status == 'sold'
                                                                    ? data.nobids ||
                                                                      fromComponent == 'home'
                                                                        ? 'Sold'
                                                                        : 'Start'
                                                                    : data.nobids || data.bid_count
                                                                    ? 'Current'
                                                                    : 'Start'}{' '}
                                                                Price{!isWizardTheme && ':'}{' '}
                                                            </span>
                                                        )}
                                                        <span className="d-flex align-items-center">
                                                            {fromComponent == 'home' ? (
                                                                <span className="prcTxtVal">
                                                                    {/* <div>{result}%</div> */}
                                                                    {currencyFormat(
                                                                        parseFloat(
                                                                            data.wprice
                                                                                ? data.wprice
                                                                                : data.bprice,
                                                                        ).toFixed(2),
                                                                        currencyType,
                                                                    )}
                                                                    <CurrencyConverterFormat
                                                                        amount={data.wprice}
                                                                    />
                                                                </span>
                                                            ) : (
                                                                <span className="prcTxtVal">
                                                                    {/* <div>{result}%</div> */}
                                                                    {currencyFormat(
                                                                        parseFloat(
                                                                            data.wprice,
                                                                        ).toFixed(2),
                                                                        checkEmursTheme
                                                                            ? data.wprice
                                                                            : currencyType,
                                                                    )}
                                                                    <CurrencyConverterFormat
                                                                        amount={data.wprice}
                                                                    />
                                                                </span>
                                                            )}

                                                            {cardTheme === 'liquidationTwo' &&
                                                                !isWizardTheme && (
                                                                    <>
                                                                        <span
                                                                            className="bidsCount"
                                                                            onClick={(e) => {
                                                                                handleBidHistoryModal(
                                                                                    data,
                                                                                )
                                                                            }}
                                                                        >
                                                                            &nbsp; |{' '}
                                                                            {data.nobids ||
                                                                                data.bid_count ||
                                                                                0}{' '}
                                                                            Bids
                                                                        </span>
                                                                    </>
                                                                )}
                                                        </span>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {' '}
                                                {data.market_status == 'closed' ? (
                                                    <span>UnSold</span>
                                                ) : (
                                                    <>
                                                        {data.auction ? (
                                                            <span className="crncyNtAvlblVlue">
                                                                <span>
                                                                    {data.market_status == 'sold'
                                                                        ? 'Sold'
                                                                        : parseInt(data.wprice) ===
                                                                          parseInt(data.sprice)
                                                                        ? 'Start'
                                                                        : 'Current'}
                                                                    Price:
                                                                </span>
                                                                {data.buynow && data.bprice ? (
                                                                    <span className="prcTxtVal">
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                data.bprice,
                                                                            ).toFixed(2),
                                                                            currencyType,
                                                                        )}
                                                                        <CurrencyConverterFormat
                                                                            amount={data.bprice}
                                                                        />
                                                                    </span>
                                                                ) : (
                                                                    <span className="gridNotAvailable">
                                                                        Not Available
                                                                    </span>
                                                                )}
                                                            </span>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </h6>
                                ) : (
                                    <div
                                        className={`d-flex align-items-center justify-content-around  ${
                                            data.market_status == 'closed' ||
                                            data.market_status == 'sold'
                                                ? 'flex-column-reverse'
                                                : 'mb-3'
                                        }`}
                                    >
                                        <h6
                                            className={`galleryPrice actnPriceVlue flex-column align-items-center mb-0 mt-0 wizardPricing ${reviewId} nowrap d-flex 1`}
                                        >
                                            {console.log(data, 'fulldata')}
                                            {(data.auction && data.wprice) ||
                                            fromComponent == 'home' ? (
                                                <>
                                                    {data.market_status == 'closed' ? (
                                                        <span className="unsold">UnSold</span>
                                                    ) : (
                                                        <>
                                                            {(data.market_status === 'sold' &&
                                                                !data.auction) ||
                                                            (data.market_status === 'sold' &&
                                                                !auction_and_buynow) ? (
                                                                <div className="sold">
                                                                    {global.pluginConfiguration
                                                                        ?.reverse_auction?.enable &&
                                                                    parseInt(data.content_head5) ==
                                                                        1 ? (
                                                                        <span>
                                                                            {data.market_status ==
                                                                            'sold'
                                                                                ? 'Sold'
                                                                                : 'Start'}{' '}
                                                                            Price
                                                                            {!isWizardTheme &&
                                                                                ':'}{' '}
                                                                        </span>
                                                                    ) : (
                                                                        <span>
                                                                            {data.market_status ==
                                                                            'sold'
                                                                                ? data.nobids ||
                                                                                  fromComponent ==
                                                                                      'home'
                                                                                    ? 'Sold'
                                                                                    : 'Start'
                                                                                : data.nobids ||
                                                                                  data.bid_count
                                                                                ? 'Current'
                                                                                : 'Start'}{' '}
                                                                            Price
                                                                            {!isWizardTheme &&
                                                                                ':'}{' '}
                                                                        </span>
                                                                    )}
                                                                    <span className="d-flex align-items-center">
                                                                        {fromComponent == 'home' ? (
                                                                            <span className="prcTxtVal">
                                                                                {currencyFormat(
                                                                                    parseFloat(
                                                                                        data.wprice
                                                                                            ? data.wprice
                                                                                            : data.bprice,
                                                                                    ).toFixed(2),
                                                                                    currencyType,
                                                                                )}
                                                                                <CurrencyConverterFormat
                                                                                    amount={
                                                                                        data.wprice
                                                                                    }
                                                                                />
                                                                            </span>
                                                                        ) : (
                                                                            <span className="prcTxtVal">
                                                                                {currencyFormat(
                                                                                    parseFloat(
                                                                                        data.wprice,
                                                                                    ).toFixed(2),
                                                                                    currencyType,
                                                                                )}
                                                                                <CurrencyConverterFormat
                                                                                    amount={
                                                                                        data.wprice
                                                                                    }
                                                                                />
                                                                            </span>
                                                                        )}
                                                                        {cardTheme ===
                                                                            'liquidationTwo' &&
                                                                            !isWizardTheme && (
                                                                                <>
                                                                                    <span
                                                                                        className="bidsCount"
                                                                                        onClick={(
                                                                                            e,
                                                                                        ) => {
                                                                                            handleBidHistoryModal(
                                                                                                data,
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        &nbsp; |{' '}
                                                                                        {data.nobids ||
                                                                                            data.bid_count ||
                                                                                            0}{' '}
                                                                                        Bids
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div className="sold activeSlot flex-column-reverse">
                                                                    {global.pluginConfiguration
                                                                        ?.reverse_auction?.enable &&
                                                                    parseInt(data.content_head5) ==
                                                                        1 ? (
                                                                        <span>
                                                                            {data.market_status ==
                                                                            'sold'
                                                                                ? 'Sold'
                                                                                : 'Start'}{' '}
                                                                            Price
                                                                            {!isWizardTheme &&
                                                                                ':'}{' '}
                                                                        </span>
                                                                    ) : (
                                                                        <span>
                                                                            {data.market_status ==
                                                                            'sold'
                                                                                ? data.nobids ||
                                                                                  fromComponent ==
                                                                                      'home'
                                                                                    ? 'Sold'
                                                                                    : 'Start'
                                                                                : data.nobids ||
                                                                                  data.bid_count
                                                                                ? 'Current'
                                                                                : 'Start'}{' '}
                                                                            Price
                                                                            {!isWizardTheme &&
                                                                                ':'}{' '}
                                                                        </span>
                                                                    )}
                                                                    <span className="d-flex align-items-center">
                                                                        {fromComponent == 'home' ? (
                                                                            <span className="prcTxtVal">
                                                                                {currencyFormat(
                                                                                    parseFloat(
                                                                                        data.wprice
                                                                                            ? data.wprice
                                                                                            : data.bprice,
                                                                                    ).toFixed(2),
                                                                                    currencyType,
                                                                                )}
                                                                                <CurrencyConverterFormat
                                                                                    amount={
                                                                                        data.wprice
                                                                                    }
                                                                                />
                                                                            </span>
                                                                        ) : (
                                                                            <span className="prcTxtVal">
                                                                                {currencyFormat(
                                                                                    parseFloat(
                                                                                        data.wprice,
                                                                                    ).toFixed(2),
                                                                                    currencyType,
                                                                                )}
                                                                                <CurrencyConverterFormat
                                                                                    amount={
                                                                                        data.wprice
                                                                                    }
                                                                                />
                                                                            </span>
                                                                        )}
                                                                        {cardTheme ===
                                                                            'liquidationTwo' &&
                                                                            !isWizardTheme && (
                                                                                <>
                                                                                    <span
                                                                                        className="bidsCount"
                                                                                        onClick={(
                                                                                            e,
                                                                                        ) => {
                                                                                            handleBidHistoryModal(
                                                                                                data,
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        &nbsp; |{' '}
                                                                                        {data.nobids ||
                                                                                            data.bid_count ||
                                                                                            0}{' '}
                                                                                        Bids
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {' '}
                                                    {data.market_status == 'closed' ? (
                                                        <span>UnSold</span>
                                                    ) : (
                                                        <>
                                                            {data.auction ? (
                                                                <span className="crncyNtAvlblVlue">
                                                                    <span>
                                                                        {data.market_status ==
                                                                        'sold'
                                                                            ? 'Sold'
                                                                            : parseInt(
                                                                                  data.wprice,
                                                                              ) ===
                                                                              parseInt(data.sprice)
                                                                            ? 'Start'
                                                                            : 'Current'}
                                                                        Price:
                                                                    </span>
                                                                    {data.buynow && data.bprice ? (
                                                                        <span className="prcTxtVal">
                                                                            {currencyFormat(
                                                                                parseFloat(
                                                                                    data.bprice,
                                                                                ).toFixed(2),
                                                                                currencyType,
                                                                            )}
                                                                            <CurrencyConverterFormat
                                                                                amount={data.bprice}
                                                                            />
                                                                        </span>
                                                                    ) : (
                                                                        <span className="gridNotAvailable">
                                                                            Not Available
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </h6>
                                        <div className="wizardCardTimer">
                                            {!noTimer && data.date_closed && (
                                                <div
                                                    className={`gcTimer primeTmCrd ${reviewId} hoTimer ${
                                                        data.buynow === 1 && data.auction === 0
                                                            ? 'noBackDrop'
                                                            : ''
                                                    }`}
                                                >
                                                    {/*eslint-disable*/}
                                                    {(data.market_status === 'open' &&
                                                        data.auction) ||
                                                    (data.market_status === 'open' &&
                                                        auction_and_buynow) ? (
                                                        <Timer
                                                            date_added={data.date_added}
                                                            date_closed={data.date_closed}
                                                            withText={1}
                                                            endText={'Time left'}
                                                            startText={'Starts in'}
                                                            theme={timerTheme}
                                                            icon={false}
                                                            audio={audio}
                                                            product_id={data.id}
                                                            viewProduct={viewProduct}
                                                            setViewProduct={setViewProduct}
                                                            // theme={'wizard'}
                                                            showDateNumber={showDateNumber}
                                                            daysText="D "
                                                            hoursText="H "
                                                            minutesText="M "
                                                            secondsText="S "
                                                        />
                                                    ) : (
                                                        <>
                                                            {data.buynow === 0 ? (
                                                                <span className="closedText">
                                                                    Auction Closed
                                                                </span>
                                                            ) : (
                                                                <div className="closedText"></div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        {global.storeDetails?.theme === 18 && (
                            <>
                                <div
                                    className={`d-flex align-items-center ${
                                        isAuthenticated
                                            ? 'justify-content-between'
                                            : 'justify-content-center'
                                    }`}
                                >
                                    {isAuthenticated && (
                                        <span
                                            className="bidHis"
                                            onClick={(e) =>
                                                bidHistry && handleBidHistoryModal(data)
                                            }
                                        >
                                            {global?.storeConfigration?.view_bid_history?.value ? (
                                                <>
                                                    &nbsp;
                                                    {data.nobids || data.bid_count || 0}
                                                    Bids
                                                </>
                                            ) : null}
                                        </span>
                                    )}
                                    {!noTimer && data.date_closed && (
                                        <div
                                            className={`gcTimer primeTmCrd   ${
                                                data.buynow === 1 && data.auction === 0
                                                    ? 'n oBackDrop'
                                                    : ''
                                            } 
                                            ${
                                                isAuthenticated &&
                                                global.storeDetails?.theme === 18 &&
                                                ''
                                            }
                                            `}
                                        >
                                            {/*eslint-disable*/}
                                            {(data.market_status === 'open' && data.auction) ||
                                            (data.market_status === 'open' &&
                                                auction_and_buynow) ? (
                                                <Timer
                                                    date_added={data.date_added}
                                                    date_closed={data.date_closed}
                                                    withText={1}
                                                    endText={'Time left' + ': '}
                                                    startText={'Starts in' + ': '}
                                                    theme={timerTheme}
                                                    icon={timerIcon}
                                                    audio={audio}
                                                />
                                            ) : (
                                                <>
                                                    {data.buynow === 0 ? (
                                                        <span className="closedText">
                                                            Auction Closed
                                                        </span>
                                                    ) : (
                                                        <div className="closedText"></div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                        {global.storeConfigration?.condition_with_color?.value == 1 ? (
                            <h6 className={`galleryPrice condition ${reviewId}`}>
                                <span>Condition: </span>
                                <span
                                    className={`prcTxtVal ${
                                        data.auctionnotes?.trim()?.toLowerCase()?.includes('new')
                                            ? 'badge badge-success text-white'
                                            : data.auctionnotes
                                                  ?.trim()
                                                  ?.toLowerCase()
                                                  ?.includes('open box')
                                            ? 'badge badge-primary text-white'
                                            : data.auctionnotes
                                                  ?.trim()
                                                  ?.toLowerCase()
                                                  ?.includes('damage')
                                            ? 'badge badge-danger text-white'
                                            : ''
                                    }`}
                                    title={data.auctionnotes ? data.auctionnotes : '-'}
                                >
                                    {data.auctionnotes ? data.auctionnotes : '-'}
                                </span>
                            </h6>
                        ) : global.storeConfigration?.show_condition?.value == 1 &&
                          global.storeDetails?.theme !== 18 ? (
                            <>
                                {cardTheme !== 'liquidation' ? (
                                    <h6 className="galleryPrice condition">
                                        <span>Condition:</span>
                                        <span
                                            className={`prcTxtVal`}
                                            title={data.auctionnotes ? data.auctionnotes : '-'}
                                        >
                                            {data.auctionnotes ? data.auctionnotes : '-'}
                                        </span>
                                    </h6>
                                ) : (
                                    ''
                                )}
                                <div className="retailMaintainHeight">
                                    {cardTheme == 'liquidation' &&
                                    global?.storeDetails?.theme == 2 ? (
                                        <>
                                            {data.mprice ? (
                                                <h6 className="galleryPrice rtlrPrice">
                                                    <span className="prcLabel">
                                                        Retail Price:{' '}
                                                        {data.retailer_link ? (
                                                            <a
                                                                href={data.retailer_link}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                (Retailer)
                                                            </a>
                                                        ) : null}
                                                    </span>
                                                    &nbsp;
                                                    <span className="prcTxtVal">
                                                        {currencyFormat(
                                                            parseFloat(data.mprice || 0).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.mprice}
                                                        />
                                                    </span>
                                                </h6>
                                            ) : (
                                                <h6 className="retailsEmpty"></h6>
                                            )}
                                        </>
                                    ) : null}
                                </div>
                            </>
                        ) : null}
                        {global.storeConfigration?.show_warehouse_location?.value == 1 ? (
                            <h6 className="galleryPrice condition">
                                <span>Location: </span>
                                <span
                                    className="prcTxtVal"
                                    title={data.location ? data.location : '-'}
                                >
                                    {data.location ? data.location : '-'}
                                </span>
                            </h6>
                        ) : null}
                        {global?.storeConfigration?.need_transferable?.value == 1 ? (
                            <h6
                                className="galleryPrice condition"
                                style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                                <span style={{ display: 'flex' }}>
                                    Transferable:
                                    {data.transferable ? (
                                        <Tooltip
                                            title={
                                                data.transferable == 'Yes'
                                                    ? 'This item can be transfered to a different warehouse location for pickup.'
                                                    : data.transferable == 'No'
                                                    ? 'This item must be picked up from its original location.'
                                                    : ''
                                            }
                                            arrow
                                            placement="top-start"
                                            open={showTooltip}
                                            onOpen={() => setShowTooltip(true)}
                                            onClose={() => setShowTooltip(false)}
                                            className="tooling"
                                            style={{ marginLeft: '5px' }}
                                        >
                                            <span onClick={() => setShowTooltip(!showTooltip)}>
                                                i
                                            </span>
                                        </Tooltip>
                                    ) : (
                                        ''
                                    )}
                                </span>
                                <span
                                    className="prcTxtVal"
                                    title={data.transferable ? data.transferable : '-'}
                                >
                                    {data.transferable ? data.transferable : '-'}
                                </span>
                            </h6>
                        ) : null}
                        {!noBuyNow && type !== 'auction' && cardTheme !== 'auctioneer' && (
                            <h6 className={`${!data.buynow ? 'noPrice' : 'galleryPrice'}`}>
                                {data.buynow && data.bprice ? (
                                    <>
                                        <span>
                                            {data.market_status === 'sold' ? 'Sold' : 'Buy Now'}{' '}
                                            Price:{' '}
                                        </span>
                                        <span className="prcTxtVal">
                                            {currencyFormat(
                                                parseFloat(data.bprice).toFixed(2),
                                                currencyType,
                                            )}
                                            <CurrencyConverterFormat amount={data.bprice} />
                                        </span>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </h6>
                        )}
                        {!noBuyNow && type !== 'auction' && cardTheme !== 'auctioneer' && (
                            <h6
                                className={`${
                                    !data.buynow ? 'noPrice' : 'galleryPrice'
                                } retailPricing`}
                            >
                                {data.buynow && data.bprice && data.mprice ? (
                                    <>
                                        <span className="prcLabel">
                                            Retail Price:{' '}
                                            {data.retailer_link ? (
                                                <a
                                                    href={data.retailer_link}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    (Retailer)
                                                </a>
                                            ) : null}
                                        </span>
                                        <span className="prcTxtVal">
                                            {currencyFormat(
                                                parseFloat(data.mprice || 0).toFixed(2),
                                                currencyType,
                                            )}
                                            <CurrencyConverterFormat amount={data.mprice} />
                                        </span>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </h6>
                        )}

                        {!noBuyNow && type !== 'auction' && cardTheme == 'auctioneer' && (
                            <>
                                {data.buynow && data.bprice ? (
                                    <div className="d-flex justify-content-between align-items-center mb-4 mt-3">
                                        <div className="price-currency">
                                            <div class="pro-price">
                                                {currencyFormat(data.bprice)}
                                            </div>
                                            <CurrencyConverterFormat amount={data.bprice} />
                                            <div className="pro-price-label">
                                                + {data.hasshipping ? 'Shipping' : 'Local Pickup'}
                                            </div>
                                        </div>
                                        <div className="pro-price-label">
                                            {/* <p>2 years warranty</p>
                                            <p>Add-ons available</p> */}
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </>
                        )}
                        {global?.storeConfigration?.buy_now_with_qty?.value == 1 ? (
                            <h6
                                // style={{ minHeight: '23px', height: '100%' }}
                                className={`${!data.buynow ? 'noPrice' : ''}`}
                            >
                                {data.buynow &&
                                data.bprice &&
                                data.category_id !=
                                    global?.storeConfigration?.similar_category?.value ? (
                                    <div className="d-flex align-items-center gap-3 justify-content-between">
                                        <span>Available Qty: </span>
                                        &nbsp;
                                        <span className="prcTxtVal">{data.qty}</span>
                                        {/* <span className="prcTxtVal">
                                                </span> */}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </h6>
                        ) : (
                            ''
                        )}
                        {lotBidding ? (
                            lotBidding
                        ) : data.date_closed &&
                          moment(data.date_closed).isValid() &&
                          auctionTimer &&
                          moment(auctionTimer).isValid() &&
                          new Date(data.date_closed).getTime() - new Date(auctionTimer).getTime() <
                              0 &&
                          !data.buynow ? (
                            <p> </p>
                        ) : data?.user_id == user?.id && data.market_status == 'open' ? (
                            <p className="cntBidOwn" style={{ whiteSpace: 'nowrap' }}>
                                {data.buynow
                                    ? 'You cannot buy your own product!'
                                    : 'You cannot bid on your own product!'}
                            </p>
                        ) : (
                            <>
                                {cardTheme == 'auctioneer' ||
                                cardTheme == 'liquidationTwo' ||
                                cardTheme == 'carAuction' ||
                                global.storeDetails.theme == 19 ? (
                                    data.auction &&
                                    !window.location.pathname.includes('gallery') &&
                                    type !== 'buynow' ? (
                                        <>
                                            <div
                                                className={`gpBidCart ${reviewId} ${
                                                    cardTheme === 'carAuction' ? 'carAucBid' : ''
                                                } ${
                                                    isWizardTheme && data.market_status === 'sold'
                                                        ? 'd-none'
                                                        : ''
                                                }`}
                                            >
                                                <Bidding
                                                    theme="multiseller"
                                                    data={data}
                                                    hard={
                                                        global.storeConfigration?.hard_bid?.value ||
                                                        '1'
                                                    }
                                                    shortText={bidBtnLabel}
                                                    isWizardBtn={isWizardTheme}
                                                    buyerAssuranceNew={isWizardTheme}
                                                    removePopup={removePopup}
                                                    detailsAuction={details}
                                                />
                                                {cardTheme !== 'carAuction' ? (
                                                    <>
                                                        {type == 'buynow' && type != 'Auction'
                                                            ? ''
                                                            : isAuthenticated &&
                                                              cardTheme != 'liquidationTwo' &&
                                                              ((parseInt(data.buynow) == 1 &&
                                                                  parseInt(data.auction) == 0) ||
                                                                  (parseInt(data.wprice) <=
                                                                      parseInt(data.bprice) &&
                                                                      parseInt(data.buynow) == 1 &&
                                                                      parseInt(data.auction) ==
                                                                          1)) &&
                                                              data.market_status == 'open' && (
                                                                  <Button
                                                                      className={`cartBtn ${
                                                                          active ? 'active' : ''
                                                                      }`}
                                                                      onClick={() =>
                                                                          handleCart(
                                                                              data.id,
                                                                              data?.date_added,
                                                                          )
                                                                      }
                                                                      disabled={data.buynow == 0}
                                                                  >
                                                                      <span className="material-icons-outlined">
                                                                          {active
                                                                              ? 'shopping_cart_checkout'
                                                                              : 'add_shopping_cart'}
                                                                      </span>
                                                                  </Button>
                                                              )}
                                                    </>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                            {cardTheme == 'liquidationTwo' ? (
                                                <>
                                                    {type == 'buynow' && type != 'Auction' ? (
                                                        <div className={`gpBidCart spByNw`}></div>
                                                    ) : ((parseInt(data.buynow) == 1 &&
                                                          parseInt(data.auction) == 0) ||
                                                          (parseInt(data.wprice) <=
                                                              parseInt(data.bprice) &&
                                                              parseInt(data.buynow) == 1 &&
                                                              parseInt(data.auction) == 1)) &&
                                                      data.market_status == 'open' ? (
                                                        <div className="gpBidCart spByNw">
                                                            {isAuthenticated ? (
                                                                <PrimaryButton
                                                                    btnSize={'small'}
                                                                    onClick={() =>
                                                                        handleCart(
                                                                            data.id,
                                                                            data?.date_added,
                                                                        )
                                                                    }
                                                                    disabled={data.buynow == 0}
                                                                    label={
                                                                        active === true
                                                                            ? 'Added to Cart'
                                                                            : cardTheme !==
                                                                              'auctioneer'
                                                                            ? `Buy it Now: ${currencyFormat(
                                                                                  data.bprice,
                                                                              )}`
                                                                            : 'Add to Cart'
                                                                    }
                                                                />
                                                            ) : (
                                                                <PrimaryButton
                                                                    btnSize={'small'}
                                                                    onClick={() =>
                                                                        handleRedirectInternal(
                                                                            history,
                                                                            'login',
                                                                        )
                                                                    }
                                                                    disabled={data.buynow == 0}
                                                                    label={`Login To Buy: ${currencyFormat(
                                                                        data.bprice,
                                                                    )}`}
                                                                />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    ) : data.market_status !== 'sold' ? (
                                        <>
                                            {cardTheme === 'liquidationTwo' &&
                                                type == 'buynow' &&
                                                type != 'Auction' && (
                                                    <div className="noBidAboveDiv"></div>
                                                )}
                                            {isAuthenticated ||
                                            global?.storeConfigration?.guest_user_login?.value ? (
                                                <PrimaryButton
                                                    btnSize={
                                                        cardTheme === 'liquidationTwo'
                                                            ? 'small'
                                                            : ''
                                                    }
                                                    onClick={() =>
                                                        handleCart(data.id, data?.date_added)
                                                    }
                                                >
                                                    {active === true
                                                        ? 'Added to Cart'
                                                        : cardTheme !== 'auctioneer'
                                                        ? `Buy it Now: ${currencyFormat(
                                                              data.bprice,
                                                          )}`
                                                        : 'Add to Cart'}
                                                </PrimaryButton>
                                            ) : (
                                                <PrimaryButton
                                                    btnSize={
                                                        cardTheme === 'liquidationTwo'
                                                            ? 'small'
                                                            : ''
                                                    }
                                                    onClick={() =>
                                                        handleRedirectInternal(history, 'login')
                                                    }
                                                >
                                                    {`Login To Buy: ${currencyFormat(data.bprice)}`}
                                                </PrimaryButton>
                                            )}
                                            {cardTheme === 'liquidationTwo' &&
                                                type == 'buynow' &&
                                                type != 'Auction' && (
                                                    <div className="text-center endDteTxt noBidDownDiv"></div>
                                                )}

                                            {/* {!isAuthenticated && (
                                                <>
                                                    {cardTheme === 'liquidationTwo' &&
                                                        type == 'buynow' &&
                                                        type != 'Auction' && (
                                                            <div className="noBidDiv"></div>
                                                        )}
                                                </>
                                            )} */}
                                        </>
                                    ) : null
                                ) : cardTheme == 'multiseller' || cardTheme == 'fundRaiser' ? (
                                    data.auction &&
                                    !window.location.pathname.includes('gallery') ? (
                                        data.date_closed &&
                                        (global.pluginConfiguration?.reverse_auction?.enable ? (
                                            <Biddingforwardandreverse
                                                theme="multiseller"
                                                data={data}
                                                hard="1"
                                                shortText={bidBtnLabel}
                                                is_registered={is_registered}
                                                private_auction={private_auction}
                                            />
                                        ) : (
                                            <>
                                                {!isBidnaa ? (
                                                    <Bidding
                                                        theme="multiseller"
                                                        data={data}
                                                        hard={
                                                            global.storeConfigration?.hard_bid
                                                                ?.value || '1'
                                                        }
                                                        shortText={bidBtnLabel}
                                                        removePopup={removePopup}
                                                    />
                                                ) : (
                                                    <>
                                                        {data.auction ? (
                                                            <div
                                                                className={`d-flex flex-wrap ${
                                                                    !isAuthenticated && 'notLogged'
                                                                }`}
                                                            >
                                                                {isAuthenticated && (
                                                                    <div className="mb-2">
                                                                        {global.storeConfigration
                                                                            ?.hard_bid?.value ==
                                                                            '1' && (
                                                                            <Bidding
                                                                                data={data}
                                                                                hard="1"
                                                                                audio={audio}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {global.storeConfigration?.proxy_bid
                                                                    ?.value == '1' && (
                                                                    <Bidding
                                                                        data={data}
                                                                        hard="0"
                                                                        audio={audio}
                                                                    />
                                                                )}
                                                            </div>
                                                        ) : null}
                                                    </>
                                                )}
                                            </>
                                        ))
                                    ) : data.market_status !== 'sold' ? (
                                        <PrimaryButton
                                            onClick={() =>
                                                isAuthenticated
                                                    ? productViewLink
                                                        ? history.push({
                                                              pathname: productViewLink,
                                                          })
                                                        : handleClick(data.id)
                                                    : handleRedirectInternal(history, 'login')
                                            }
                                        >
                                            {isAuthenticated ? 'Buy Now' : 'Login To Buy'}
                                        </PrimaryButton>
                                    ) : null
                                ) : cardTheme == 'HeavyEquipment' ? (
                                    <div className="gaCTA">
                                        <PrimaryButton
                                            onClick={() =>
                                                productViewLink
                                                    ? history.push({
                                                          pathname: productViewLink,
                                                      })
                                                    : handleClick(data.id)
                                            }
                                        >
                                            View Details
                                        </PrimaryButton>
                                        <AddToCalendar data={data} />
                                    </div>
                                ) : global?.storeConfigration?.qty_input_slider?.value == 1 &&
                                  data.buynow ? (
                                    ''
                                ) : new Date(data.date_added) > new Date() &&
                                  data.content_head5 == 1 &&
                                  global.pluginConfiguration?.reverse_auction?.enable &&
                                  !data?.make_an_offer_io ? (
                                    <p>Wait until auction starts!</p>
                                ) : (
                                    <div className="timer-text mt-2">
                                        {!noBidButton && link && fromComponent != 'home' && (
                                            <>
                                                {data.id !== undefined ? (
                                                    <div
                                                        className={`${
                                                            isAuthenticated && 'gridItemAct'
                                                        } ${
                                                            isAuthenticated &&
                                                            data.auction != 0 &&
                                                            (bidText == 'Winning' ||
                                                                bidText == 'Won') &&
                                                            'winBtnWrpr'
                                                        } ${
                                                            isAuthenticated &&
                                                            data.auction != 0 &&
                                                            (bidText == 'Outbid' ||
                                                                bidText == 'Lost') &&
                                                            'outbidBtnWrpr'
                                                        }`}
                                                    >
                                                        <PrimaryButton
                                                            disabled={data.market_status == 'sold'}
                                                            name={data.id}
                                                            onClick={() =>
                                                                isAuthenticated
                                                                    ? productViewLink
                                                                        ? history.push({
                                                                              pathname:
                                                                                  productViewLink,
                                                                          })
                                                                        : handleClick(data.id)
                                                                    : handleRedirectInternal(
                                                                          history,
                                                                          'login',
                                                                      )
                                                            }
                                                            label={
                                                                window.location.pathname.includes(
                                                                    'search',
                                                                ) ||
                                                                type === 'Auction' ||
                                                                data.auction
                                                                    ? (type === 'buynow' ||
                                                                          data.buynow) &&
                                                                      (!data.auction ||
                                                                          window.location.href.includes(
                                                                              '/gallery',
                                                                          ))
                                                                        ? isAuthenticated
                                                                            ? 'Buy Now'
                                                                            : 'Login To Buy Now'
                                                                        : isAuthenticated
                                                                        ? bidText
                                                                        : 'Login To Bid'
                                                                    : isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                            }
                                                            btnColor={
                                                                data.latestbid_user == user?.id &&
                                                                'success'
                                                            }
                                                        />
                                                        {global.storeDetails?.theme === 18 && (
                                                            <div className="lctnTxtWrpr d-flex align-items-center justify-content-end">
                                                                <span className="material-icons">
                                                                    location_on
                                                                </span>
                                                                <span className="location-class">
                                                                    {data?.auction_city ||
                                                                        productLocalState?.globalLocation}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {cardTheme !== 'carAuction' &&
                                                        global?.storeConfigration?.qty_input_slider
                                                            ?.value != 1 &&
                                                        data.market_status == 'open' &&
                                                        cardTheme !== 'LotsAuction' ? (
                                                            <>
                                                                {type != 'buynow' &&
                                                                type == 'Auction'
                                                                    ? ''
                                                                    : isAuthenticated &&
                                                                      parseInt(data.wprice) <=
                                                                          parseInt(data.bprice) && (
                                                                          <Button
                                                                              className={`cartBtn ${
                                                                                  active
                                                                                      ? 'active'
                                                                                      : ''
                                                                              } `}
                                                                              onClick={() =>
                                                                                  handleCart(
                                                                                      data.id,
                                                                                      data?.date_added,
                                                                                  )
                                                                              }
                                                                              disabled={
                                                                                  data.buynow ==
                                                                                      0 ||
                                                                                  user?.status ==
                                                                                      'suspended'
                                                                              }
                                                                              //   disabled={
                                                                              //       data.buynow == 0 ||
                                                                              //       data.market_status == 'sold' ||
                                                                              //       parseInt(data.bprice) <
                                                                              //           parseInt(data.wprice)
                                                                              //   }
                                                                          >
                                                                              <span className="material-icons-outlined">
                                                                                  {active
                                                                                      ? 'shopping_cart_checkout'
                                                                                      : 'add_shopping_cart'}
                                                                              </span>
                                                                          </Button>
                                                                      )}
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}

                                                        {cardTheme !== 'multiseller' &&
                                                            cardTheme !== 'LotsAuction' &&
                                                            cardTheme !== 'liquidationTwo' &&
                                                            cardTheme !== 'carAuction' &&
                                                            data.market_status === 'open' && (
                                                                <FavouriteCheckbox
                                                                    watchlisted={
                                                                        data.watchlistid ||
                                                                        data.watchlisted ||
                                                                        data.isFav ||
                                                                        data.watch
                                                                    }
                                                                    project_id={data.id}
                                                                    getAllProducts={getAllProducts}
                                                                    data={data}
                                                                    from={'card'}
                                                                    viewProduct={viewProduct}
                                                                    setViewProduct={setViewProduct}
                                                                />
                                                            )}
                                                    </div>
                                                ) : (
                                                    <Link
                                                        className={`${'pink-btn pbtn-sm'} ${
                                                            isAuthenticated &&
                                                            data.auction != 0 &&
                                                            bidText == 'Winning' &&
                                                            'winBtnWrpr'
                                                        } ${
                                                            isAuthenticated &&
                                                            data.auction != 0 &&
                                                            bidText == 'Losing' &&
                                                            'outbidBtnWrpr'
                                                        }`}
                                                        to={link}
                                                        params={{ product_id: data.id }}
                                                    >
                                                        {window.location.pathname.includes(
                                                            'search',
                                                        ) ||
                                                        type === 'Auction' ||
                                                        data.auction
                                                            ? type === 'buynow'
                                                                ? isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                                : isAuthenticated
                                                                ? bidText
                                                                : 'Login To Bid'
                                                            : isAuthenticated
                                                            ? 'Buy Now'
                                                            : 'Login To Buy Now'}{' '}
                                                        <i className="fa fa-long-arrow-alt-right"></i>
                                                    </Link>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                        {global?.storeConfigration?.qty_input_slider?.value == 1 && data.buynow ? (
                            <>
                                <div className="newAdded">
                                    <Qtyinputcard
                                        total_qty={data.qty}
                                        qty={'1'}
                                        product_id={data.id}
                                        disabled={active}
                                        isAuthenticated={isAuthenticated}
                                        history={history}
                                    />
                                    {data.market_status == 'open' && (
                                        <FavouriteCheckbox
                                            watchlisted={
                                                data.watchlistid ||
                                                data.watchlisted ||
                                                data.isFav ||
                                                data.watch
                                            }
                                            project_id={data.id}
                                            getAllProducts={getAllProducts}
                                            data={data}
                                            from={'card'}
                                            viewProduct={viewProduct}
                                            setViewProduct={setViewProduct}
                                        />
                                    )}
                                </div>
                            </>
                        ) : (
                            ''
                        )}
                        {cardTheme === 'liquidationTwo' && (
                            <>
                                {/* <Tooltip
                                    title={
                                        <>
                                            {!noTimer && data.date_closed && (
                                                <div
                                                    className={`gcTimer ${
                                                        data.buynow === 1 ? 'noBackDrop' : ''
                                                    }`}
                                                >
                                                    {(data.market_status === 'open' &&
                                                        data.auction) ||
                                                    (data.market_status === 'open' &&
                                                        auction_and_buynow) ? (
                                                        <Timer
                                                            date_added={data.date_added}
                                                            date_closed={data.date_closed}
                                                            withText={0}
                                                            endText={'Time left' + ': '}
                                                            startText={'Starts in' + ': '}
                                                            theme={timerTheme}
                                                            icon={timerIcon}
                                                        />
                                                    ) : (
                                                        <>
                                                            {data.buynow === 0 ? (
                                                                <span className="closedText">
                                                                    Auction Closed
                                                                </span>
                                                            ) : (
                                                                <div className="closedText"></div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    }
                                > */}
                                {data.auction == 1 && type != 'buynow' && !isWizardTheme ? (
                                    <div className="text-center endDteTxt">
                                        {data.market_status === 'open' ? (
                                            <>
                                                {cardTheme == 'liquidationTwo' ? (
                                                    <p className="mb-0">
                                                        Ends{' '}
                                                        {`${moment(data.date_closed)
                                                            .tz(
                                                                global?.storeConfigration
                                                                    ?.auction_view_time_zone?.value
                                                                    ? global?.storeConfigration
                                                                          ?.auction_view_time_zone
                                                                          ?.value
                                                                    : moment.tz.guess(),
                                                            )
                                                            .format('MMM Do')}, ${moment(
                                                            data.date_closed,
                                                        )
                                                            .tz(
                                                                global?.storeConfigration
                                                                    ?.auction_view_time_zone?.value
                                                                    ? global?.storeConfigration
                                                                          ?.auction_view_time_zone
                                                                          ?.value
                                                                    : moment.tz.guess(),
                                                            )
                                                            .format('h:mm a')}`}
                                                    </p>
                                                ) : (
                                                    <p className="mb-0">
                                                        Ends {dateFormatFront(data.date_closed)}
                                                    </p>
                                                )}
                                            </>
                                        ) : (
                                            <p className="mb-0">Auction Closed</p>
                                        )}
                                    </div>
                                ) : null}
                                {/* </Tooltip> */}
                            </>
                        )}
                    </>
                )}
                <div className="onlyHomeLiqCard">
                    {global.storeDetails?.theme === 18 ? (
                        <PrimaryButton
                            btnSize=""
                            onClick={() =>
                                isAuthenticated
                                    ? productViewLink
                                        ? history.push({
                                              pathname: productViewLink,
                                          })
                                        : handleClick(data.id)
                                    : handleRedirectInternal(history, 'login')
                            }
                        >
                            {isArtTheme ? (
                                <>{isAuthenticated ? t('Bid') : t('login_to_bid')}</>
                            ) : (
                                <>{isAuthenticated ? t('bid_now') : t('login_to_bid')}</>
                            )}
                        </PrimaryButton>
                    ) : null}
                </div>
            </div>
            {isArtTheme && (
                <div className="artCardHover d-md-flex">
                    <div>
                        <h4 className="ProTit" onClick={() => handleClick(data.id)}>
                            {data.ptitle}
                        </h4>
                        <div className="priceCrd">
                            {Boolean(data.auction) ? (
                                <>
                                    <div className="cPrice">
                                        <h4>{t('current_bid')}</h4>
                                        <span className="currency">
                                            {currencyFormat(data.wprice)}
                                        </span>
                                    </div>
                                    <span className="crncyValue makemycurrency">
                                        <CurrencyConverterFormat amount={data.wprice} />
                                    </span>
                                </>
                            ) : (
                                ''
                            )}
                            {Boolean(data.buynow) ? (
                                <div className="bPrice">
                                    <h4>{t('buy_now_price')}</h4>
                                    <span>{currencyFormat(data.bprice)}</span>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div>
                        {!noTimer && data.date_closed && (
                            <div className={`gcTimer ${data.buynow === 1 ? 'noBackDrop' : ''}`}>
                                {(data.market_status === 'open' && data.auction) ||
                                (data.market_status === 'open' && auction_and_buynow) ? (
                                    <Timer
                                        date_added={data.date_added}
                                        date_closed={data.date_closed}
                                        withText={1}
                                        endText={
                                            isArtTheme ? t('time_left') : t('time_left') + ': '
                                        }
                                        startText={t('starts_in') + ': '}
                                        theme={timerTheme}
                                        audio={audio}
                                    />
                                ) : (
                                    <>
                                        {data.buynow === 0 ? (
                                            <span className="closedText">Auction Closed</span>
                                        ) : (
                                            <div className="closedText"></div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <Bidhistory
                modaltitle="Bid history"
                open={Object.keys(historyData).length !== 0}
                value={historyData}
                handleClose={() => setHistoryData({})}
            />
            {isWizardTheme && (
                <>
                    <WizardTermsPopup
                        open={showPopup}
                        onAccept={() => acceptTerms()}
                        handleClose={() => setShowPopup(false)}
                        product={data}
                    />
                </>
            )}
        </div>
    )
}

export default GridItem
